{
  "cardRecord": {
    "expand": "Expand record",
    "collapse": "Collapse record"
  },
  "reservedMaterialReview": {
    "operation": "Operation {{number}}",
    "reserved": "Outstanding reservation: {{amount}}",
    "quantity": "Quantity to consume of {{code}}",
    "refresh": "Return to the panel and open the review to refresh the reserved balance and operation link."
  },
  "accessRestricted": {
    "title": "Access restricted",
    "body": "Your role does not allow access to this page. Contact your account administrator."
  },
  "notFound": {
    "title": "Page not found",
    "body": "This address does not match an available page. Return to chat to continue.",
    "back": "Back to chat"
  },
  "symptomPrompt": {
    "title": "SYMPTOM",
    "question": "What happened with the equipment? Describe it in your own words.",
    "placeholder": "E.g.: oil leak at the pump seal",
    "helper": "Write the problem as you would tell a colleague.",
    "submitLabel": "Send"
  },
  "procedureAuthoring": {
    "title": "CREATE PROCEDURE",
    "escolha": {
      "greeting": "Hi, {{name}}! What would you like to do?"
    },
    "rascunhos": {
      "title": "My drafts",
      "empty": "You have no drafts.",
      "resume": "Continue",
      "steps_one": "{{count}} step",
      "steps_other": "{{count}} steps"
    },
    "equipamento": {
      "title": "Equipment",
      "searchLabel": "Search by code or name",
      "searchButton": "Search",
      "select": "Select",
      "empty": "No equipment found."
    },
    "pontoDePartida": {
      "question_one": "Use the plan's simple step for this equipment?",
      "question_other": "Use the plan's {{count}} simple steps for this equipment?"
    },
    "cabecalho": {
      "title": "Header",
      "name": "Procedure name",
      "namePlaceholder": "E.g.: Pump seal replacement",
      "objective": "Objective",
      "safety": "Safety (lockout, PPE)",
      "safetyPlaceholder": "Optional",
      "duration": "Duration (minutes)",
      "crew": "Crew"
    },
    "passo": {
      "title": "Step {{index}}",
      "titleOf": "Step {{index}} of {{total}}",
      "text": "What to do in this step",
      "textPlaceholder": "E.g.: Shut down and lock out the pump before opening the cover",
      "camera": "Camera",
      "importImage": "Import image",
      "photos": "Step photos",
      "photoItem": "Photo {{n}}",
      "removePhoto": "Remove photo {{n}}",
      "uploading": "Uploading photo...",
      "photoFailed": "The photo could not be uploaded.",
      "photoTooLarge": "The photo is still larger than 1 MB. Try another."
    },
    "revisao": {
      "title": "Review",
      "summary_one": "{{count}} step, {{photos}} with photo",
      "summary_other": "{{count}} steps, {{photos}} with photo",
      "editStep": "Edit step {{n}}",
      "editLabel": "Edit a step"
    },
    "vinculo": {
      "title": "Link equipment",
      "question": "Link now to one or more pieces of equipment?",
      "none": "No equipment available."
    },
    "pausado": {
      "title": "Draft saved",
      "body": "To continue: /criar-procedimento and Continue draft."
    },
    "concluido": {
      "title": "Procedure",
      "steps_one": "{{count}} step",
      "steps_other": "{{count}} steps",
      "photos_one": "{{count}} photo",
      "photos_other": "{{count}} photos",
      "equipment_one": "{{count}} equipment linked",
      "equipment_other": "{{count}} equipment linked",
      "statusCreated": "Draft",
      "statusReleased": "Published"
    }
  },
  "procFoto": {
    "coluna": "Photo",
    "camera": "Camera",
    "importar": "Import image",
    "pular": "Skip",
    "adicionar": "Add photo",
    "naoConsigo": "I can't take a photo",
    "motivoLabel": "Reason for not taking a photo",
    "motivoPlaceholder": "E.g.: no light on site",
    "enviando": "Uploading photo…",
    "erroGrande": "The photo is still too large after compression. Take another with less detail.",
    "erroIlegivel": "Unsupported format. Use a JPG or PNG photo.",
    "erroEnvio": "The photo could not be uploaded. Try again.",
    "previa": "Photo preview",
    "remover": "Remove photo",
    "ampliar": "Enlarge photo",
    "fechar": "Close",
    "fotoAlt": "Attached photo",
    "carregando": "Loading photo…",
    "indisponivel": "Photo unavailable",
    "politica": {
      "title": "PHOTO ON NOTIFICATION AND ORDER",
      "intro": "Choose when a photo is requested. The change applies to the whole company.",
      "notificacao": "Notification",
      "ordem": "Work order",
      "off": "Off",
      "optional": "Optional",
      "required": "Required",
      "salvar": "Save policy",
      "somenteLeitura": "Only administrators can change this policy.",
      "salvo": "Photo policy saved"
    }
  },
  "admin": {
    "title": "Admin Dashboard",
    "subtitle": "An operational view of your plant.",
    "loading": "Loading admin data…",
    "forbidden": "You do not have permission to view this page.",
    "error": "Could not load admin data. Please try again.",
    "metrics": {
      "totalEquipments": "Total equipment",
      "activeEquipments": "Active equipment",
      "openWorkOrders": "Open work orders",
      "openNotifications": "Open notifications",
      "criticalNotifications": "Critical notifications",
      "activeMaintPlans": "Active maintenance plans",
      "completedWoThisMonth": "WOs completed this month",
      "pmc": "Planned maintenance compliance (%)",
      "totalPlants": "Plants",
      "totalLocations": "Locations",
      "goToSection": "View {{section}}",
      "draftMaintPlans": "Draft maintenance plans"
    },
    "tabs": "Admin sections",
    "tabDashboard": "Dashboard",
    "tabEntities": "Entity browser",
    "backToConversation": "Back to conversation",
    "sectionMenu": "Section menu",
    "sections": {
      "dashboard": "Dashboard",
      "equipment": "Equipment",
      "plants": "Plants",
      "locations": "Locations",
      "materials": "Materials",
      "workOrders": "Work orders",
      "maintPlans": "Maintenance plans",
      "notifications": "Notifications",
      "proposals": "Proposals (AI)",
      "auditLog": "Audit log",
      "sessions": "Sessions",
      "skills": "Skills",
      "inventoryTurnover": "Inventory turnover",
      "recursos": "Resources",
      "specialties": "Specialties",
      "config": "Config",
      "i18n": "Languages",
      "entities": "Entity browser",
      "flowGraph": "Axis Flow"
    },
    "flowGraph": {
      "subtitle": "Graph of the onboarding flow: each node is a screen, decision, or reasoning step Axis takes, and each edge is a deterministic flow transition.",
      "hint": "Hover a node to highlight its connections. Click for Axis to resume the walk from there. Drag to rearrange.",
      "canvasLabel": "Axis onboarding flow graph",
      "legend": {
        "render": "Screen (shows something)",
        "decision": "Decision (the user chooses)",
        "agentic": "Axis reasoning (research)",
        "pending": "Queued (to be built)"
      },
      "zones": {
        "onboarding": "Onboarding",
        "operations": "Day-to-day operation"
      }
    },
    "proposals": {
      "subtitle": "AI-generated proposals awaiting review.",
      "filterStatus": "Filter by status",
      "empty": "No proposals found.",
      "showItems": "Show items",
      "hideItems": "Hide items",
      "approve": "Approve",
      "reject": "Reject",
      "reviewFailed": "Could not record the decision. The list was refreshed with the current state.",
      "status": {
        "all": "All statuses",
        "pending": "Pending",
        "approved": "Approved",
        "partial": "Partial",
        "rejected": "Rejected",
        "expired": "Expired",
        "auto_approved": "Auto-approved",
        "executed": "Executed",
        "unknown": "Unknown"
      },
      "type": {
        "field_update": "Update field",
        "create_notification": "Create notification",
        "create_work_order": "Create work order",
        "horizon_refill": "Refill horizon",
        "unknown": "Unknown"
      },
      "col": {
        "created": "Created",
        "type": "Type",
        "items": "Items",
        "field": "Field",
        "current": "Current",
        "proposed": "Proposed",
        "confidence": "Confidence"
      }
    },
    "auditLog": {
      "aiActor": "AI assistant",
      "integrationActor": "Integration",
      "unknownActor": "Unidentified source",
      "actions": {
        "create": "Created",
        "update": "Updated",
        "delete": "Deleted",
        "approve": "Approved",
        "reject": "Rejected",
        "status_change": "Status changed",
        "state_transition": "Conversation progress",
        "flow_run_node_persisted": "Conversation step recorded",
        "unknown": "Other action"
      },
      "systemActor": "System process",
      "unavailableActor": "User unavailable",
      "subtitle": "Audit trail of changes in this tenant.",
      "exportCsv": "Export CSV",
      "filterEntity": "Filter by entity",
      "filterAction": "Filter by action",
      "allEntities": "All entities",
      "allActions": "All actions",
      "dateFrom": "From date",
      "dateTo": "To date",
      "col": {
        "when": "When",
        "actor": "Actor",
        "entity": "Entity",
        "action": "Action",
        "diff": "Change"
      }
    },
    "sessions": {
      "subtitle": "Skill gateway status and active sessions.",
      "online": "Gateway online",
      "offline": "Gateway offline",
      "skillsCount": "{{count}} skills loaded",
      "empty": "No active sessions.",
      "col": {
        "id": "ID",
        "channel": "Channel",
        "user": "User",
        "lastActivity": "Last activity",
        "status": "Status"
      }
    },
    "skills": {
      "subtitle": "Skills loaded by the gateway.",
      "empty": "No skills loaded.",
      "noDescription": "No description"
    },
    "inventory": {
      "subtitle": "Excess materials ordered by immobilized capital.",
      "selectPlant": "Select a plant…",
      "searchPlaceholder": "code or description",
      "choosePlantHint": "Select a plant to view inventory turnover.",
      "empty": "No excess materials in this plant.",
      "excess": "Excess",
      "col": {
        "code": "Code",
        "description": "Description",
        "unit": "Unit",
        "currentStock": "Current stock",
        "available": "Available",
        "maxStock": "Max stock",
        "excessQty": "Excess",
        "capital": "Immobilized capital",
        "status": "Status"
      }
    },
    "recursos": {
      "subtitle": "Resource roster (technicians) and their capacity.",
      "searchPlaceholder": "name, email or personnel no.",
      "filterPlant": "Filter by plant",
      "filterRole": "Filter by role",
      "allPlants": "All plants",
      "allRoles": "All roles",
      "empty": "No resources found.",
      "col": {
        "name": "Name",
        "role": "Role",
        "team": "Team",
        "plant": "Plant",
        "email": "Email",
        "personnel": "Personnel no.",
        "weekly": "Weekly capacity",
        "daily": "Daily capacity"
      }
    },
    "specialties": {
      "title": "Maintenance Specialties",
      "subtitle": "Manage your team's technical disciplines. Each team is linked to a specialty.",
      "columns": {
        "name": "Name",
        "slug": "Code",
        "status": "Status",
        "isDefault": "Default"
      },
      "namePlaceholder": "Specialty name",
      "addButton": "Add",
      "editButton": "Edit",
      "saveButton": "Save",
      "cancelButton": "Cancel",
      "deleteButton": "Delete",
      "deactivateButton": "Deactivate",
      "activateButton": "Activate",
      "showInactive": "Show inactive",
      "active": "Active",
      "inactive": "Inactive",
      "isDefault": "System",
      "confirmDelete": "Delete this specialty? Linked teams prevent deletion.",
      "empty": "No active specialties. Create the first one.",
      "errors": {
        "inUse": "In use by {{count}} team(s). Deactivate instead of deleting.",
        "isDefault": "System default specialties cannot be deleted. Deactivate them.",
        "saveFailed": "Failed to save. Please try again.",
        "loadFailed": "Failed to load specialties."
      },
      "seeds": {
        "mechanical": "Mechanical",
        "electrical": "Electrical",
        "instrumentation": "Instrumentation",
        "lubrication": "Lubrication",
        "operator": "Operator",
        "general": "General"
      }
    },
    "config": {
      "subtitle": "Harness parameters (whitelist).",
      "searchPlaceholder": "key or description",
      "filterScope": "Filter by scope",
      "allScopes": "All scopes",
      "saved": "Saved",
      "reset": "Reset",
      "resetBtn": "Reset",
      "saveFailed": "Failed to save.",
      "invalidJson": "Invalid JSON.",
      "confirmReset": "Reset this parameter to its default value?",
      "default": "Default (not overridden)",
      "overridden": "Overridden",
      "overriddenBy": "Updated by {{name}}"
    },
    "reset": {
      "reveal": "Danger zone",
      "warning": "This WIPES the entire base (all data) and recreates it from scratch. Irreversible action.",
      "passwordLabel": "Reset password",
      "confirm": "Reset base",
      "confirmAgain": "Confirm reset, click again",
      "running": "Resetting the base…",
      "success": "Base reset successfully.",
      "wrongPassword": "Incorrect password.",
      "cooldown": "Wait a few seconds before resetting again.",
      "forbidden": "Reset is not allowed in this environment.",
      "error": "Failed to reset the base."
    },
    "dangerZone": {
      "typedLabel": "Type {{phrase}} to confirm",
      "unavailable": "This action is available only to the company Owner or Admin on an authorized test base.",
      "title": "Danger zone",
      "buttonLabel": "Reset base now",
      "warning": "This action deletes the current company’s operational data in {{environment}} and recreates its base. Accounts, authentication, audit records and other companies’ data are preserved. Irreversible.",
      "confirm1Warning": "Confirm deleting the current company’s operational data in {{environment}}? This action cannot be undone.",
      "proceedToPassword": "Yes, proceed",
      "passwordLabel": "Enter the base reset password",
      "passwordPlaceholder": "Reset password",
      "confirmButton": "Confirm total reset",
      "submitting": "Resetting…",
      "cancel": "Cancel",
      "successToast": "Base {{environment}} reset successfully.",
      "wrongSecret": "Wrong reset password.",
      "cooldown": "Wait a few seconds before resetting again.",
      "genericError": "Failed to reset the base. Please try again.",
      "noPermission": "Only the company Owner or Admin can reset the base.",
      "locked": "Wrong reset password 3 times. The reset is locked for {{minutes}} min.",
      "verificationUnavailable": "The reset password could not be checked right now. Try again in a few minutes.",
      "reauthExpired": "The confirmation expired. Enter the reset password again.",
      "sessionExpired": "Your session expired. Sign in again and repeat the reset.",
      "setupTitle": "Set the base reset password",
      "setupHint": "Before the first reset, set a password here just for this action. It is separate from your sign-in, so it also works if you sign in with Google. At least {{min}} characters.",
      "newPasswordLabel": "New reset password",
      "confirmPasswordLabel": "Repeat the new reset password",
      "saveSetup": "Save reset password",
      "saving": "Saving…",
      "setupSaved": "Reset password saved. You can now reset the base.",
      "tooShort": "The reset password must have at least {{min}} characters.",
      "mismatch": "The two passwords do not match.",
      "resetPasswordNotSet": "This base has no reset password yet. Set it right here, on this screen.",
      "alreadySet": "The reset password is already set. To change it, enter the current one.",
      "changeTitle": "Change the reset password",
      "currentPasswordLabel": "Current reset password",
      "saveChange": "Change reset password",
      "changeSaved": "Reset password changed.",
      "resetNotApplied": "The cleanup was not applied: the data was preserved. After fixing the cause, enter the reset password again to confirm another attempt.",
      "resetPartial": "The server reported a possibly partial cleanup. Check its status before starting another cleanup.",
      "resetOutcomeUnknown": "The cleanup result could not be confirmed. Check its status before starting another cleanup.",
      "retryButton": "Confirm another cleanup attempt",
      "serverTimestamp": "Time reported by the server:",
      "checkStatus": "Check cleanup status",
      "checkingStatus": "Checking status…",
      "resetStillRunning": "A cleanup is still running for this company. Wait and check its status again.",
      "resetStatusUnavailable": "The status could not be checked now. No new cleanup was started.",
      "operationReference": "Operation reference:",
      "resetMaintenanceUnavailable": "Safe cleanup is temporarily unavailable for this base. The environment configuration needs to be fixed; no new cleanup will be started meanwhile.",
      "newCleanupWarning": "The previous result still has no success confirmation. Starting another cleanup requires a new confirmation and password; it does not confirm or resume the previous operation.",
      "startNewCleanup": "Start a new cleanup",
      "resetAlreadyRunning": "A cleanup is already running for this company. Check its status before starting another."
    },
    "i18n": {
      "subtitle": "Harness language configuration.",
      "supportedLanguages": "Supported languages",
      "defaultLanguage": "Default language",
      "fallbackLanguage": "Fallback language",
      "detectionStrategy": "Detection strategy",
      "allowUserOverride": "Allow user override",
      "addLang": "Add",
      "removeLang": "Remove {{lang}}",
      "invalidTag": "Invalid BCP-47 tag.",
      "saved": "Saved",
      "saveFailed": "Failed to save."
    },
    "grid": {
      "search": "Search",
      "searchPlaceholder": "Search records…",
      "filters": "Filters",
      "filtersGroup": "Column filters",
      "filterPlaceholder": "Value…",
      "filterBy": "Filter by {{field}}",
      "columns": "Columns",
      "compact": "Compact",
      "comfortable": "Comfortable",
      "refresh": "Refresh",
      "export": "Export Excel",
      "exporting": "Exporting…",
      "exportFailed": "Export failed. Please try again.",
      "exportTooLarge": "Too many rows to export, refine the filter and try again.",
      "clearAll": "Clear all",
      "removeFilter": "Remove {{field}} filter",
      "tableCaption": "Entity records",
      "expandColumn": "Expand row",
      "expandRow": "Expand row",
      "collapseRow": "Collapse row",
      "copyId": "Copy ID",
      "copied": "Copied",
      "pagination": "Pagination",
      "totalRows": "Total rows:",
      "prev": "Previous",
      "next": "Next",
      "jumpToPage": "Jump to page",
      "ofPages": "of {{count}}",
      "empty": "No records match the current filters.",
      "loadError": "Could not load records.",
      "retry": "Retry",
      "schemaError": "Could not load the model schema.",
      "selectModel": "Select a model to browse.",
      "searchModels": "Search models…",
      "modelList": "Models"
    },
    "workOrderDetail": {
      "descriptionTitle": "Description",
      "longTextLabel": "Long text",
      "notificationTitle": "Linked Notification",
      "notificationCol": {
        "id": "ID",
        "description": "Description"
      },
      "operationsTitle": "Operations ({{count}})",
      "operationsEmpty": "No operations registered",
      "operationsCol": {
        "seq": "Seq",
        "description": "Description",
        "plannedDuration": "Planned Duration",
        "technician": "Technician",
        "status": "Status"
      },
      "componentsTitle": "Materials ({{count}})",
      "componentsEmpty": "No components linked",
      "componentsCol": {
        "material": "Material",
        "description": "Description",
        "qty": "Qty",
        "unit": "Unit",
        "origin": "Origin"
      },
      "needsPurchase": "Purchase",
      "fromStock": "Stock"
    }
  },
  "common": {
    "appName": "AxiomGO",
    "tagline": "AI Guidance & Maintenance Orchestration",
    "send": "Send",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "close": "Close",
    "loading": "Loading...",
    "retry": "Try again",
    "settings": "Settings",
    "help": "Help",
    "yes": "Yes",
    "no": "No",
    "delete": "Delete"
  },
  "chat": {
    "composerRecovery": {
      "storageFailed": "Your message could not be prepared. Your text has been kept. Please try again.",
      "available": "Text from your previous submission is available to review.",
      "restore": "Recover text"
    },
    "expandCard": {
      "expand": "Expand card",
      "expandedBadge": "Card opened fullscreen",
      "title": {
        "equipment_search": "Equipment result",
        "import": "Import",
        "kpi": "Indicators",
        "plan_edit": "Maintenance plan: review",
        "preventive_draft": "Preventive plan: draft",
        "proposal": "Proposal",
        "resource_allocation": "Resource allocation",
        "task_materials": "Materials per task",
        "web_search": "Suggested plan, built by Axis"
      }
    },
    "placeholder": "Ask about assets, failures, plans or work orders…",
    "axisKPanelSubtitle": "Describe a problem or ask for a technical analysis",
    "placeholders": [
      "Type / to see what I can do",
      "Register an asset: tag, manufacturer and model",
      "Build a suggested plan from the manufacturer's manual",
      "Ask: why is compressor GA37 vibrating?"
    ],
    "placeholderByFlow": {
      "corretiva": "Describe the failure and I will open the work order",
      "preventiva": "Adjust intervals or tasks in the maintenance plan"
    },
    "commandPalette": {
      "notifications": "List notifications",
      "unavailable": "Commands unavailable",
      "empty": "No command. Send as text"
    },
    "disclaimer": "AxiomGO can make mistakes. Confirm actions before running them.",
    "newConversation": "New chat",
    "copyConversation": "Copy conversation",
    "copyConversationRoleUser": "You",
    "history": "History",
    "typing": "Typing...",
    "noConversations": "No conversations yet",
    "mockResponse": "received your message. Engine integration is pending.",
    "reconnectAttempt": "attempt {{count}}",
    "suggestedActions": "Suggested actions",
    "assistant_avatar_alt": "AxiomGO",
    "stopProcessing": "Stop",
    "cancel": "Cancel",
    "turnTimedOut": "The response took too long. Please try again.",
    "turnGaveUp": "The answer never finished. Nothing you already had was lost: tap \"Try again\" to pick it back up.",
    "inactivity": {
      "pausedAt": "Paused due to inactivity · {{time}}.",
      "saved": "Your spreadsheet is still saved.",
      "resume": "Resume"
    },
    "copyMessage": "Copy message",
    "retryMessage": "Try again",
    "recommended": "Recommended",
    "writeYourOwn": "or write your own",
    "criticalConfirmation": {
      "materialConsumption": {
        "title": "Confirm material consumption",
        "confirm": "Confirm consumption",
        "prompt": "Confirm consumption of {{items}}?",
        "promptWithOrder": "Confirm consumption of {{items}} for order {{order}}?"
      },
      "workOrderClosure": { "title": "Confirm work order closure", "confirm": "Confirm closure" },
      "yes": "Yes",
      "no": "No",
      "confirmMessage": "Yes, I confirm.",
      "expiredNote": "The confirmation expired. Ask for the action again.",
      "unboundNote": "I could not identify the conversation for this confirmation. Request the action again.",
      "cancelledNote": "Action cancelled.",
      "ariaLabel": "Critical action confirmation",
      "closeNoteLabel": "Closing note",
      "closeNotePlaceholder": "Describe what was done…",
      "closeNoteCounter": "{{count}} characters",
      "closeNoteCounterMinimum": "{{count}} of {{minChars}} minimum characters",
      "wandLabel": "Improve note",
      "wandPending": "Improving note…"
    },
    "deliveryFailed": "Send failed, tap \"Try again\"",
    "deliveryFailedShort": "Failed",
    "envioNaoSaiu": "Could not send right now. Check your connection and tap again.",
    "nadaParaReenviar": "There is nothing to resend from this message. Please write your request again.",
    "emptyResponseHint": "This response didn't come through this time. Tap \"Try again\" or rephrase your question.",
    "actionFailure": {
      "notCompleted": "was not completed"
    },
    "reasoning": {
      "thinking": "Thinking...",
      "done": "Response details",
      "failed": "Processing interrupted",
      "stalledHint": "Processing, just a moment...",
      "error": "The response was interrupted.",
      "retry": "Retry"
    },
    "message": {
      "renderError": {
        "title": "We couldn't render this response",
        "body": "This message's content came through corrupted. The rest of the conversation keeps working. Tap \"Try again\" to resend your last message.",
        "retry": "Try again"
      }
    },
    "onboardingWaiting": {
      "preparing": "Preparing your welcome..."
    },
    "onboardingUploadCard": {
      "attachButton": "Attach spreadsheet",
      "dropHint": "or drop the file here",
      "sent": "Spreadsheet sent",
      "closed": "Spreadsheet upload closed"
    },
    "searchWait": {
      "background": "You can continue in other conversations. Research keeps running in the background and we will notify you when it finishes.",
      "title": "Technical research in progress",
      "body": "Axis is consulting web sources: manufacturer manuals and maintenance recommendations to ground the answer.",
      "duration": "Research and plan preparation can take up to 5 minutes.",
      "elapsed": "{{elapsed}} elapsed"
    },
    "planTasksPartial": {
      "region": "Plan tasks under validation",
      "badge": "Under validation",
      "counter_one": "{{count}} task",
      "counter_other": "{{count}} tasks",
      "note": "Preview while the plan is being built. Nothing has been saved; the final plan replaces this table."
    },
    "progress": {
      "searching": "Searching the web...",
      "sources": "Analyzing sources found...",
      "analyzing": "Processing with AI...",
      "tools": "Executing action...",
      "generating": "Generating response...",
      "reasoning": "Reasoning..."
    },
    "contextMeter": {
      "label": "Context usage",
      "tooltip": "{{tokensK}}/{{limitK}}K tokens",
      "warning": "Conversation near limit, consider starting a new one"
    },
    "fallbackActions": {
      "ariaLabel": "Suggested next steps",
      "welcome": {
        "cadastrarEquipamentos": {
          "label": "Register my equipment",
          "value": "I want to register my equipment"
        },
        "montarPlano": {
          "label": "Build maintenance plan",
          "value": "I want to build a maintenance plan"
        },
        "comoFunciona": {
          "label": "How does management work?",
          "value": "explain how I manage maintenance execution"
        }
      },
      "equipment": {
        "montarPlanoEsses": {
          "label": "Build plan for this equipment",
          "value": "build a plan for my registered equipment"
        }
      },
      "equipmentTag": {
        "assumirDefault": {
          "label": "Use Tag {{tag}}",
          "value": "use tag {{tag}}"
        },
        "assumirShort": {
          "label": "Use Tag {{tag}}",
          "value": "use tag {{tag}}"
        },
        "preferencia": {
          "label": "Enter my own tag",
          "value": "I want to enter my own tag"
        },
        "outraOpcao": {
          "label": "Suggest another option",
          "value": "suggest another tag option"
        }
      },
      "plan": {
        "iniciarExecucao": {
          "label": "Start plan execution",
          "value": "start plan execution"
        },
        "editarTarefas": {
          "label": "Edit plan tasks",
          "value": "I want to edit the plan tasks"
        },
        "adicionarEquipamentos": {
          "label": "Add more equipment to plan",
          "value": "add equipment to the plan"
        }
      },
      "kpi": {
        "verDashboard": {
          "label": "View full dashboard",
          "value": "show the KPI dashboard"
        },
        "priorizarMelhorias": {
          "label": "Which improvements to prioritize?",
          "value": "which improvements should I prioritize based on KPIs?"
        },
        "configurarAlertas": {
          "label": "Configure KPI alerts",
          "value": "I want to configure alerts for critical KPIs"
        }
      },
      "searchFailure": {
        "cadastrarManual": {
          "label": "Register with basic data",
          "value": "please register the equipment with the basic data we have"
        },
        "tentarBuscaAlternativa": {
          "label": "Try alternative search",
          "value": "try the search with alternative terms"
        },
        "abrirSemCadastro": {
          "label": "Open without full registration",
          "value": "open the notification with basic data, without full registration"
        }
      }
    },
    "attachment": {
      "ariaLabel": "Attachment: {{filename}}, {{size}}",
      "sizeKb": "{{size}} KB",
      "sizeMb": "{{size}} MB"
    },
    "machineEnvelope": {
      "importProgress": "Import running: {{imported}} of {{total}} rows. I will let you know when it finishes.",
      "generic": "I received a system update that this version of the screen cannot display yet. The operation went through normally."
    },
    "renameFailed": "Could not rename the conversation. The previous name was kept.",
    "deleteFailed": "Could not delete the conversation. It is still in your list; try again.",
    "scrollToBottom": "Scroll to the end",
    "chips": {
      "grupo": {
        "indicador": "Indicators",
        "auditoria": "Data audit"
      }
    }
  },
  "settings": {
    "sections": "Account settings",
    "title": "Preferences",
    "lang": {
      "label": "Language"
    },
    "theme": {
      "label": "Theme",
      "shine": "Shine",
      "night": "Night"
    },
    "notifications": {
      "label": "System notifications",
      "enable": "Enable system notifications",
      "enabled": "System notifications enabled",
      "denied": "Notifications blocked in the browser. Change it in your device settings.",
      "unsupported": "This browser does not support system notifications"
    }
  },
  "sidebar": {
    "userMenu": {
      "open": "Open account menu for {{name}}",
      "account": "My account"
    },
    "models": "Models",
    "settings": "Settings",
    "openSettings": "Open preferences",
    "adminDashboard": "Admin dashboard",
    "toggle": "Toggle sidebar",
    "toggleTheme": "Toggle theme",
    "language": "Language",
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar",
    "newConversation": "New Conversation",
    "dashboard": "Dashboard",
    "plans": "Preventive Plans",
    "seed": {
      "dashboard": "Analyze machine ",
      "plans": "List the preventive plans for "
    },
    "fallbackTitle": "New conversation · {{time}}",
    "groups": {
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This week",
      "thisMonth": "This month",
      "earlier": "Earlier"
    }
  },
  "dashboard": {
    "title": "Maintenance KPIs",
    "subtitle": "MTBF, MTTR, availability and backlog computed in real time.",
    "summary": "Tenant summary",
    "equipmentSeries": "Equipment time series",
    "equipmentTrend": "MTBF trend (last 6 months)",
    "topFailureModes": "Top 5 failure modes",
    "equipmentSelector": "Select equipment",
    "periodSelector": "Select period",
    "period": {
      "last30d": "Last 30 days",
      "last90d": "Last 90 days",
      "mtd": "Month to date",
      "ytd": "Year to date",
      "last12m": "Last 12 months",
      "all": "All history",
      "custom": "Other period"
    },
    "kpi": {
      "mtbf": {
        "label": "MTBF",
        "description": "Mean Time Between Failures, industrial target is > 100h."
      },
      "mttr": {
        "label": "MTTR",
        "description": "Mean Time To Repair, target is < 4h for corrective work."
      },
      "availability": {
        "label": "Availability",
        "description": "Uptime over analyzed window. Target > 95%."
      },
      "backlog": {
        "label": "Backlog",
        "description": "Open work orders not yet completed."
      }
    },
    "source": {
      "fallback": "WO fallback",
      "fallbackTooltip": "Computed from corrective work orders, Sprint C Incident model not yet enabled."
    },
    "empty": {
      "series": "No corrective work orders in the window to build a trend.",
      "noEquipment": "Register an equipment to display the time series."
    },
    "error": {
      "scopeRequired": "Equipment or plant is required.",
      "loadFailed": "Could not load the data. Please try again.",
      "retry": "Retry"
    },
    "card": {
      "openPlans": "View plans",
      "confidence": {
        "label": "Confidence",
        "high": "high",
        "medium": "medium",
        "low": "low"
      },
      "export": {
        "xlsx": "Export Excel",
        "docx": "Export Word (.docx)",
        "pdf": "Export PDF",
        "generating": "Generating…",
        "error": "Could not generate the file. Try again."
      },
      "plans": {
        "count_one": "{{count}} preventive plan",
        "count_other": "{{count}} preventive plans",
        "empty": "No preventive plans found.",
        "openTasks": "View tasks",
        "searchPlaceholder": "Search plan or equipment",
        "viewSchedule": "View Schedule",
        "noSearchResults": "No plan matches the search."
      },
      "seed": {
        "setPeriod": "Analyze machine {{tag}} over {{period}}",
        "customPeriod": "Analyze machine {{tag}} from ",
        "openPlans": "List the preventive plans for {{tag}}",
        "planTasks": "List the tasks of plan {{plan}}"
      },
      "teams": {
        "title": "Teams",
        "count_one": "{{count}} team registered",
        "count_other": "{{count}} teams registered",
        "empty": "No teams registered yet.",
        "emptyMatch": "None of them match what you asked for.",
        "col": {
          "name": "Team",
          "tag": "Code",
          "plant": "Plant",
          "specialty": "Specialty",
          "technicians": "Technicians"
        }
      },
      "materials": {
        "title": "Materials",
        "count_one": "{{count}} material registered",
        "count_other": "{{count}} materials registered",
        "empty": "No materials registered yet.",
        "emptyMatch": "None of them match what you asked for.",
        "col": {
          "code": "Code",
          "description": "Description",
          "unit": "Unit",
          "manufacturer": "Manufacturer",
          "partNumber": "Part number",
          "equipmentLinks": "Equipment"
        }
      },
      "notifications": {
        "title": "Notifications",
        "openCount_one": "{{count}} open notification",
        "openCount_other": "{{count}} open notifications",
        "matchedCount_one": "{{count}} in this search",
        "matchedCount_other": "{{count}} in this search",
        "pageRange": "Showing {{from}} to {{to}}",
        "empty": "No notifications found.",
        "col": {
          "number": "Number",
          "equipment": "Equipment",
          "type": "Type",
          "priority": "Priority",
          "status": "Status",
          "actions": "Actions",
          "detailing": "Detailing"
        },
        "status": {
          "open": "Open",
          "in_progress": "In progress",
          "closed": "Closed"
        },
        "type": {
          "M1": "Breakdown notice",
          "M2": "Malfunction notice",
          "M3": "Activity notice"
        },
        "action": {
          "aria": "{{action}}: notification {{number}}",
          "detail": "Detail",
          "complete": "Complete detailing",
          "open": "Open WO",
          "resume": "Resume the existing WO"
        },
        "detailing": {
          "sem_os": "No work order",
          "incompleta": "Incomplete work order",
          "detalhada": "Detailed work order",
          "conflito": "Conflicting link",
          "bloqueada": "Detailing unavailable",
          "unknown": "Detailing not provided"
        },
        "missing": {
          "operation_description": "Operation description",
          "operation_team": "Operation team",
          "operation_specialty": "Operation specialty",
          "planned_start": "Planned date",
          "operation_duration": "Operation duration",
          "operation_duration_unit": "Duration unit",
          "operation_system_condition": "Installation condition",
          "operations": "Operations",
          "unknown": "Required information"
        }
      },
      "list": {
        "count_one": "{{count}} item",
        "count_other": "{{count}} items",
        "countTruncated_one": "Showing {{shown}} of {{count}} item",
        "countTruncated_other": "Showing {{shown}} of {{count}} items",
        "countRange": "Showing {{from}}-{{to}} of {{total}}",
        "tools": {
          "search": "Search the list",
          "searchPlaceholder": "Search the list",
          "sort": "Sort the list",
          "sortDefault": "Original order",
          "sortAsc": "{{column}} (A to Z)",
          "sortDesc": "{{column}} (Z to A)",
          "columns": "Columns",
          "export": "Export CSV",
          "pagination": "List pages",
          "noMatch": "No item matches this search or filter.",
          "filterBy": "Filter by {{column}}",
          "filterAll": "{{column}}: all"
        },
        "empty": "No items found.",
        "detail": {
          "show": "View details",
          "hide": "Hide details"
        },
        "action": {
          "header": "Action",
          "execute": "Run"
        }
      }
    },
    "buildFooter": {
      "label": "AxiomGO · v{{version}} · build {{sha}}",
      "ariaLabel": "System build version"
    }
  },
  "engine": {
    "online": "Engine Online",
    "offline": "Engine Offline",
    "reconnecting": "Reconnecting..."
  },
  "errors": {
    "connectionLost": "Connection lost. Reconnecting...",
    "timeout": "The server did not respond in time. Please try again.",
    "generic": "Something went wrong. Try again or contact support.",
    "invalidFormat": "Invalid format. Check your data and try again.",
    "sessionExpired": "Your session expired. Please refresh the page.",
    "authError": "Session expired. Please sign in again.",
    "sessionRenewing": "Re-authenticating your session…",
    "sessionRenewed": "Session renewed. If your last action did not go through, tap it again.",
    "permissionDenied": "You don't have permission to access this resource.",
    "rateLimited": "Too many requests. Please wait a few seconds.",
    "networkBlocked": "We couldn't reach the server. Check your connection and try again.",
    "streamFailed": "The response was interrupted. Tap \"Try again\" to resend.",
    "credentialTimeout": "I could not renew your credential in time. Check your connection and tap again.",
    "auth": {
      "invalidTenant": "Invalid or missing tenant. Contact your organization's administrator.",
      "providerUnavailable": "The authentication provider is temporarily unavailable. Please try again shortly.",
      "notConfigured": "Authentication is not configured. Contact your system administrator.",
      "notApproved": "Only approved accounts can access the platform."
    },
    "stream": {
      "llmUnavailable": "The AI model is temporarily unavailable. Please try again in a few seconds.",
      "turnDeadlineExceeded": "The conversation didn't respond in time and this turn was closed. Please send it again.",
      "requestUnconfirmed": "The previous request has no confirmed result yet. We did not start another execution to avoid duplication. Reopen the conversation to check the response before trying again.",
      "internalError": "Something went wrong in the engine. Try again or contact support."
    },
    "uniqueness": {
      "equipmentDuplicateTagInPlant": "Equipment with tag \"{{tag}}\" is already registered in plant \"{{plantName}}\". The existing record will be reused.",
      "locationDuplicateCodeInPlant": "A location with code \"{{code}}\" already exists in plant \"{{plantName}}\". Use a different code or choose another plant.",
      "teamDuplicateNameInPlant": "A team with name \"{{name}}\" already exists in plant \"{{plantName}}\". Use a different name or choose another plant.",
      "technicianDuplicatePersonnelNumberInTenant": "A technician with personnel number \"{{personnelNumber}}\" already exists in this tenant. Use a different personnel number."
    },
    "boundary": {
      "title": "Something went wrong in this part of the screen",
      "message": "The rest of AxiomGO keeps working. Reload to try again.",
      "retry": "Reload"
    },
    "loadRolesFailed": "Could not load the access roles.",
    "loadTeamFailed": "Could not load the team members."
  },
  "toasts": {
    "proposalApproved": "Proposal approved successfully",
    "proposalRejected": "Proposal rejected",
    "proposalAdjusted": "Proposal adjusted",
    "engineReconnected": "Engine reconnected",
    "newConversation": "New conversation started",
    "themeChanged": "Theme changed",
    "importComplete": "Import complete, {{count}} rows",
    "importCompleteGeneric": "Import complete",
    "importError": "Import failed, tap to retry",
    "webSearchComplete": "Search complete",
    "copyConversationSuccess": "Conversation copied",
    "voicePermissionLost": "Microphone permission lost. Use the keyboard.",
    "rateLimited": "You sent too many messages. Wait {{seconds}}s and try again.",
    "turnInFlight": "Wait for the current reply to finish. Your message is still in the field, ready to send again.",
    "messageDropped": "We lost part of the system's response. If the screen looks frozen, reload the page."
  },
  "proposal": {
    "approve": "Approve",
    "adjust": "Adjust",
    "reject": "Reject",
    "confidence": "Confidence"
  },
  "files": {
    "download": "Download",
    "attach": "Attach file",
    "camera": "Camera",
    "capturePhoto": "Take photo",
    "photoAttachment": "Photo",
    "cameraNativePermissionDenied": "Camera access denied. Allow access in the app settings and try again.",
    "cameraUnavailable": "The camera is unavailable on this device.",
    "cameraCaptureFailed": "The photo could not be captured or read. Please try again.",
    "cameraPermissionDenied": "Camera access was denied. Please allow camera access in your browser settings and try again.",
    "unsupportedFormat": "\"{{filename}}\" is not a supported format.",
    "fileTooLarge": "\"{{filename}}\" is too large. Maximum is 200MB for PDF, 50MB for other files and 20MB for images.",
    "tooManyFiles": "Maximum 10 files per message.",
    "types": {
      "spreadsheet": "Spreadsheet",
      "csv": "CSV",
      "pdf": "PDF",
      "document": "Document",
      "image": "Image",
      "text": "Text",
      "generic": "File"
    },
    "uploadFailed": "Failed to upload the file. Please try again.",
    "attachmentContextChanged": "The attachment context changed. Select the file again before sending.",
    "uploadTenantMissing": "Session without tenant. Please sign in again.",
    "uploading": "Uploading file...",
    "gallery": "Gallery",
    "uploadFailedStatus": "Upload failed (error {{status}}). Please try again.",
    "uploadMissingFileId": "The server received the file but returned no identifier. Please try again.",
    "durableAttachmentsDisabled": "Can't send \"{{filename}}\" right now (large files of this type aren't enabled yet). Try a smaller file or wait for it to be enabled."
  },
  "processing": {
    "default": "Processing..."
  },
  "form": {
    "submit": "Submit",
    "submitted": "Details sent"
  },
  "validation": {
    "tagFormat": "Incorrect format. Example: BOM-2201A",
    "notaFormat": "Incorrect format. Enter 8 to 10 digits.",
    "ordemFormat": "Incorrect format. Enter 7 to 12 digits.",
    "currencyInvalid": "Invalid currency value.",
    "currencyNegative": "Currency cannot be negative.",
    "dateInvalid": "Invalid date. Check the format."
  },
  "input": {
    "quickActions": "Quick actions",
    "suggestionsAvailable": "{{count}} suggestions available",
    "chatAriaLabel": "Chat message input"
  },
  "conversation": {
    "delete": {
      "confirm": "Delete this conversation? This action cannot be undone.",
      "button": "Delete"
    },
    "empty": {
      "title": "Your plant, orchestrated.",
      "subtitle": "From registration to the preventive plan, from failure to a completed work order: AxiomGO conducts every step with you.",
      "cta": "New chat"
    },
    "untitled": "Untitled conversation",
    "edit": {
      "placeholder": "Conversation name",
      "title": "Edit the conversation name"
    },
    "rename": "Rename",
    "menu": "More options"
  },
  "import": {
    "analyzeFailed": "Failed to analyze the spreadsheet. Please try again.",
    "executeFailed": "Failed to run the import. Nothing was imported. Check your connection and try again.",
    "proposal": {
      "title": "Import: {{fileName}}",
      "rows": "{{count}} rows",
      "columns": "{{count}} columns",
      "entity": "Detected entity: {{entity}}",
      "unmapped": "{{count}} unmapped columns",
      "issues": "{{count}} issues detected",
      "confirm": "Import with this mapping",
      "confirmWithId": "I confirm the import for proposal {{proposalId}} with the displayed mappings.",
      "adjust": "Adjust mapping",
      "cancel": "Cancel",
      "adjustPlaceholder": "Describe the desired adjustments (e.g., \"XPTO is the asset number\")",
      "table": {
        "source": "Your Column",
        "target": "AxiomGO Field",
        "confidence": "Conf.",
        "sample": "Sample"
      },
      "processing": "Processing..."
    },
    "progress": {
      "title": "Importing {{entity}}...",
      "enqueued": "{{entity}} import queued",
      "completed": "{{entity}} import completed",
      "completedWithErrors": "{{entity}} import completed with errors",
      "failed": "{{entity}} import failed",
      "records": "{{processed}} / {{total}} records",
      "imported": "{{count}} imported",
      "skipped": "{{count}} skipped",
      "errors": "{{count}} errors",
      "eta": "Estimated time: ~{{time}}"
    },
    "report": {
      "success": "Import completed!",
      "failure": "Import failed",
      "imported": "{{count}} {{entity}} imported",
      "autocreated": "{{count}} dependencies created",
      "skipped": "{{count}} duplicates skipped",
      "errors": "{{count}} rows with errors",
      "duration": "Duration: {{time}}",
      "download": "Download error report"
    },
    "validation": {
      "title": "Validation complete",
      "valid": "{{count}} valid rows",
      "errors": "{{count}} rows with errors",
      "warnings": "{{count}} warnings",
      "missingTitle": "Missing dependencies:",
      "missing": "{{count}} {{entity}} not found",
      "duplicates": "{{count}} records already exist",
      "importAnyway": "Import anyway",
      "createAndImport": "Create dependencies and import",
      "processing": "Processing..."
    },
    "entity": {
      "Equipment": "Equipment",
      "Location": "Locations",
      "Plant": "Plants",
      "Material": "Materials",
      "MaintPlan": "Maintenance Plans",
      "WorkOrder": "Work Orders",
      "Team": "Teams",
      "Technician": "Technicians",
      "Notification": "Notifications",
      "Supplier": "Suppliers",
      "Specialty": "Specialties"
    },
    "templateOffer": {
      "title": "Don't have a template yet?",
      "subtitle": "Download a ready-to-fill Excel model and import it back.",
      "levelLabel": "Model:",
      "levelBasic": "Basic (required fields)",
      "levelFull": "Full (all fields)",
      "langLabel": "Language:",
      "downloadAll": "Download all (.zip)",
      "downloadingAll": "Building bundle...",
      "error": "Failed to download template: {{msg}}"
    },
    "dropzone": {
      "text": "Drop file to import",
      "unsupported": "Unsupported format. Use .xlsx, .xls, or .csv",
      "uploading": "Uploading...",
      "analyzing": "Analyzing...",
      "sent": "Sent"
    },
    "file": {
      "size": {
        "kb": "{{size}} KB",
        "mb": "{{size}} MB"
      },
      "rows": "{{count}} rows",
      "sheets": "{{count}} sheets"
    },
    "detection": {
      "detected": "Spreadsheet identified as {{entity}} ({{confidence}}% confidence)",
      "lowConfidence": "I couldn't identify the data type with certainty. Looks like {{entity}}, can you confirm?",
      "unknown": "I didn't recognize the data type. Can you tell me what this spreadsheet contains?",
      "learned": "Recognized this format from previous imports",
      "profileAutoApplied": "Learned profile auto-applied"
    },
    "defaults": {
      "applied": "{{field}} set to {{value}} ({{standard}})",
      "criticality_b": "Criticality B applied, ISO 55001 default for unclassified assets"
    },
    "dependencies": {
      "willCreate": "{{entity}} '{{name}}' will be created automatically",
      "created": "{{entity}} '{{name}}' created successfully",
      "failed": "Could not create {{entity}} '{{name}}': {{reason}}"
    },
    "template": {
      "askEntity": "What type of data do you need a template for?",
      "generating": "Generating {{entity}} template...",
      "ready": "{{entity}} template ready!",
      "downloadHint": "Download, fill in, and send back to import.",
      "requiredColumns": "Required columns: {{columns}}",
      "exampleIncluded": "I included a real example from your database."
    },
    "webSearch": {
      "consultedWeb": "Web search performed",
      "dataFrom": "Based on the manufacturer manual",
      "maintenancePlan": "Preventive Maintenance Plan",
      "manufacturer": "Manufacturer",
      "model": "Model",
      "equipmentType": "Type",
      "viewSources": "View sources ({{count}})",
      "hideSources": "Hide sources",
      "importOffer": "Import preventive plan?",
      "importTasks_zero": "{{count}} tasks",
      "importTasks_one": "{{count}} task",
      "importTasks_other": "{{count}} tasks",
      "importYes": "Yes, import",
      "importInfo": "Just the info",
      "importStarted": "Import started",
      "infoOnly": "Ok, keeping the info only",
      "confidence": "confidence",
      "cached": "cached data",
      "cachedAgo": "from {{time}} ago"
    },
    "webSearchCard": {
      "plan": {
        "period": {
          "horas": "HOURS",
          "diario": "DAILY",
          "semanal": "WEEKLY",
          "mensal": "MONTHLY",
          "anual": "ANNUAL",
          "ciclos": "CYCLES",
          "naoEspecificado": "UNSPECIFIED"
        },
        "totals": "PLAN TOTALS",
        "importQuestion": "Import the preventive plan?",
        "importYes": "Yes, import",
        "importInfoOnly": "Just the info",
        "seeDetails": "see details",
        "hideDetails": "hide details",
        "technicianNotSpecified": "Not specified"
      }
    },
    "multiSheet": {
      "analysisTitle": "Analyzed your spreadsheet \"{{fileName}}\"",
      "sheetsFound": "{{count}} sheet(s) found",
      "rowCount": "{{count}} records",
      "unrecognizedSheet": "Unrecognized sheet, will be skipped",
      "unmapped": "No match",
      "colExcel": "Column",
      "colCmms": "AxiomGO Field",
      "colConfidence": "Conf.",
      "colSheet": "Sheet",
      "colEntity": "Entity",
      "approveAll": "Import all",
      "reviewDependencies": "Review dependencies",
      "cancel": "Cancel",
      "dependenciesTitle": "Missing dependencies",
      "dependenciesCount": "{{count}} item(s) need to be created",
      "selectAll": "Select all",
      "createAndImport": "Create selected and import",
      "skipAndImport": "Skip and import without creating",
      "noAutoCreate": "Cannot be auto-created",
      "registerPlantFirst": "Register the plant first",
      "registerViaChatFirst": "Register it via chat before importing",
      "readyToImport": "Ready to import",
      "recordsSummary": "{{records}} records in {{sheets}} sheets",
      "depsToCreate": "+ {{count}} items to create",
      "importOrder": "Import order",
      "executeImport": "Execute import",
      "back": "Back",
      "importing": "Importing {{entity}}...",
      "importingSheet": "Sheet \"{{sheet}}\" ({{current}}/{{total}})",
      "completed": "Import completed",
      "partial": "Partial import",
      "failed": "Import failed",
      "duration": "Completed in {{seconds}}s",
      "created": "Created",
      "updated": "Updated",
      "skipped": "Skipped",
      "errors": "Errors",
      "rowError": "Row {{row}}: {{message}}",
      "reasonMissing": "The import failed and the response carried no reason. Download the error report or upload the spreadsheet again.",
      "nothingExecutable": "No sheet is cleared for import. Sheets recognized with partial confidence need your confirmation before any row is written."
    },
    "job": {
      "title": "Import in progress",
      "titleCompleted": "Import completed",
      "titleCompletedWithErrors": "Import completed with errors",
      "correctionsApplied": "Corrections applied",
      "correctionsPartial": "Corrections partially applied",
      "initialProcessing": "Initial processing:",
      "titleFailed": "Import failed",
      "titleCanceled": "Import canceled",
      "titleStalled": "Import not responding",
      "state": {
        "pending": "Pending",
        "enqueued": "Queued",
        "running": "Importing...",
        "completed": "Completed",
        "completed_with_errors": "Completed with errors",
        "failed": "Failed",
        "canceled": "Canceled",
        "stalled": "No response"
      },
      "stalled": {
        "title": "Import not responding",
        "body": "No update received from the server. The import may still be running or may have stopped.",
        "checkNow": "Check now",
        "dismiss": "Dismiss"
      },
      "imported": "Imported",
      "skipped": "Skipped",
      "errors": "Errors",
      "failedRows": "Failed rows",
      "currentSheet": "Current sheet",
      "duration": "Duration: {{seconds}} s",
      "viewFailedRows": "View failed rows",
      "viewSkippedRows": "View skipped rows",
      "errorMessage": "Error: {{message}}",
      "skippedSheets_one": "{{count}} sheet not recognized: {{names}}",
      "skippedSheets_other": "{{count}} sheets not recognized: {{names}}",
      "fixedActions": {
        "openCorrectiveOrder": "Open corrective work order",
        "generateMaintenancePlan": "Generate maintenance plan",
        "viewMyEquipment": "View my equipment"
      }
    },
    "pendingSheet": {
      "title": "Sheets awaiting your confirmation:",
      "row": "{{sheet}}: looks like {{entity}} ({{rows}} rows)",
      "accept": "Import as {{entity}}",
      "ignore": "Skip this sheet",
      "accepted": "Sheet confirmed. The import was queued.",
      "ignored": "Sheet skipped. Nothing was imported from it.",
      "failed": "Could not record the decision. Try again."
    },
    "failedRows": {
      "title": "Failed rows ({{count}})",
      "colRow": "Row",
      "colSheet": "Sheet",
      "colField": "Field",
      "colReason": "Reason",
      "loading": "Loading...",
      "empty": "No detail available for this job.",
      "loadError": "Could not load the failed rows. Try again.",
      "retry": "Retry",
      "prev": "← Previous",
      "next": "Next →",
      "download": "Download error report",
      "close": "Close",
      "colCorrecao": "Correction",
      "escolha": "Choose...",
      "semTipoConhecido": "Fix it in the spreadsheet and import again",
      "corrigirCampo": "Fix {{campo}}",
      "cadastreDependencia": "Register {{entidade}} before resending this row",
      "reenviar": "Reimport {{count}} corrected row(s)",
      "reenviando": "Reimporting...",
      "linhaCorrigida": "Fixed",
      "linhaFalhou": "Still failing",
      "contagem": "{{total}} failures → {{corrigidas}} fixed → {{pendentes}} pending",
      "erroVazio": "Fill in this field",
      "erroNumero": "Use a number",
      "erroData": "Date does not exist",
      "erroOpcao": "Choose one of the listed values",
      "erroBooleano": "Use yes or no",
      "erroSemTipo": "This field cannot be fixed here",
      "erroAoReenviar": "Could not reimport the rows. Please try again.",
      "valorQueVeio": "Came as: {{valor}}"
    },
    "skippedRows": {
      "title": "Skipped rows ({{count}})",
      "colRow": "Row",
      "colSheet": "Sheet",
      "colReason": "Reason",
      "loading": "Loading...",
      "empty": "No row was skipped in this import.",
      "loadError": "Could not load the skipped rows. Try again.",
      "retry": "Retry",
      "prev": "← Previous",
      "next": "Next →",
      "close": "Close",
      "reason": {
        "duplicate": "Duplicate row",
        "no_match": "Row did not match any record",
        "other": "Reason not classified by the system"
      },
      "reasonFallback": "Row not recognized. Check this row's data."
    },
    "inlineForm": {
      "code": "Code",
      "codeExemplo": "PL-02",
      "name": "Name",
      "nameExemplo": "Piracicaba Plant",
      "country": "Country (2 letters)",
      "countryExemplo": "BR",
      "timezone": "Time zone",
      "timezoneExemplo": "America/Sao_Paulo",
      "erroObrigatorio": "Fill in this field",
      "erroPais": "Use the 2-letter country code, such as BR",
      "erroFuso": "Time zone does not exist. Use the America/Sao_Paulo format",
      "erroAoCriar": "Could not create the record. Please try again.",
      "criando": "Creating record..."
    }
  },
  "search": {
    "webIndicator": "Searched the web · suggestion based on the {{manufacturer}} manual",
    "webIndicatorCached": "(cached {{hours}}h ago)",
    "viewDetails": "View full details",
    "hideDetails": "Hide details",
    "viewSources": "View sources ({{count}})",
    "hideSources": "Hide sources",
    "sourcesTitle": "Sources consulted",
    "importOffer": "Register this suggested preventive plan for {{tag}}?",
    "importTaskCount": "{{count}} tasks will be created with the suggested intervals. Review before applying.",
    "importYes": "Yes, import",
    "importNo": "No, just the info",
    "importSuccess_zero": "Suggestion reviewed and registered: preventive plan with {{count}} tasks. Next {{task}}: {{date}}.",
    "importSuccess_one": "Suggestion reviewed and registered: preventive plan with {{count}} task. Next {{task}}: {{date}}.",
    "importSuccess_other": "Suggestion reviewed and registered: preventive plan with {{count}} tasks. Next {{task}}: {{date}}.",
    "importSuccessNoNext_zero": "Suggestion reviewed and registered: preventive plan with {{count}} tasks.",
    "importSuccessNoNext_one": "Suggestion reviewed and registered: preventive plan with {{count}} task.",
    "importSuccessNoNext_other": "Suggestion reviewed and registered: preventive plan with {{count}} tasks.",
    "importPending": "Importing the preventive plan. Waiting for the engine to confirm.",
    "importStillProcessing": "The import is still processing. The confirmation shows up here in the conversation as soon as it finishes.",
    "importFailedTitle": "I could not import the preventive plan.",
    "importError": "Return to the conversation and ask me to import the plan again.",
    "confidenceHigh": "high confidence",
    "confidenceMedium": "medium confidence",
    "confidenceLow": "low confidence",
    "noResults": "No data found for {{manufacturer}} on the web."
  },
  "webSearch": {
    "consultedWeb": "Searched the web",
    "dataFrom": "suggestion based on the manufacturer manual",
    "headerLabel": "Consulted web · suggestion based on the manufacturer manual",
    "headerLabelLibrary": "From the Library · {{when}}",
    "headerLabelManual": "Read the attached manual · suggestion based on the manual",
    "headerLabelNeutral": "Web search",
    "maintenancePlan": "Preventive Maintenance Plan",
    "preventivePlanLabel": "Preventive plan",
    "planTotals": "Plan totals",
    "manufacturer": "Manufacturer",
    "model": "Model",
    "equipmentType": "Type",
    "viewSources": "View sources ({{count}})",
    "hideSources": "Hide sources",
    "importOffer": "Import preventive plan?",
    "importTasks_zero": "{{count}} tasks",
    "importTasks_one": "{{count}} task",
    "importTasks_other": "{{count}} tasks",
    "importYes": "Yes, import",
    "importInfo": "Just the info",
    "importStarted": "Import started",
    "infoOnly": "Ok, keeping the info only",
    "confidence": {
      "badgeLabel": "{{pct}}%",
      "noData": "no data",
      "tooltip": "Confidence {{pct}}%, {{chunks}} chunks from {{urls}} URLs",
      "noDataTooltip": "Confidence data not available"
    },
    "cached": "cached data",
    "cachedAgo": "from {{time}} ago",
    "taskCount_zero": "{{count}} tasks",
    "taskCount_one": "{{count}} task",
    "taskCount_other": "{{count}} tasks",
    "durationEstimated": "(est.)",
    "materialsLabel": "Materials",
    "toolsLabel": "Tools",
    "lubricantLabel": "Lubricant",
    "workTypeLabel": "Discipline",
    "peopleRequiredLabel": "Crew",
    "peopleRequiredValue_one": "{{count}} person",
    "peopleRequiredValue_other": "{{count}} people",
    "noPlanFound": "No specific plan found for {{manufacturer}} {{model}}. You can:",
    "openManual": "Open manufacturer manual",
    "registerManually": "Register this equipment",
    "usualPlanDisclaimer": "We could not find the equipment manual, so we inferred a plan following market practice.",
    "headerInferred": "Consulted web · suggestion based on similar equipment",
    "headerMarketPractice": "Consulted web · suggestion based on class practices and standards",
    "inferredDisclaimer": "We could not find the manual for {{manufacturer}} {{model}}, so we inferred a plan following market practice.",
    "registerEquipmentCta": "Register this equipment",
    "montarPlanoPreventivo": "Build the Preventive Plan",
    "refineSearch": "Refine search",
    "unavailable": {
      "title": "Plan research",
      "body": "The plan research service is unavailable at the moment."
    },
    "noSources": {
      "title": "No sources found",
      "body": "I couldn't find any web sources for {{manufacturer}} {{model}}. You can register the equipment manually.",
      "retry": "Try again",
      "registerManually": "Register this equipment"
    },
    "workType": {
      "electrical": "Electrical",
      "mechanical": "Mechanical",
      "instrumentation": "Instrumentation",
      "hydraulic": "Hydraulic",
      "pneumatic": "Pneumatic",
      "lubrication": "Lubrication",
      "civil": "Civil",
      "inspection": "Inspection",
      "other": "Other"
    },
    "lowConfidenceTitle": "Low confidence",
    "lowConfidenceHint": "Verify against the manufacturer manual before applying.",
    "notRegisteredTitle": "Equipment not registered",
    "notRegisteredBody": "I couldn't find {{manufacturer}} {{model}} in your records. Shall I create the equipment and import the {{count}}-task preventive plan?",
    "confirmCreateAndImport": "Create and import",
    "creatingAndImporting": "Creating equipment and importing plan...",
    "createCancelled": "Ok, keeping only the manufacturer information.",
    "plan": {
      "presentation": {
        "pendingField": "Translation pending",
        "unavailableField": "Translation unavailable",
        "pending": "Preparing plan translation…",
        "unavailable": "Plan translation unavailable. The plan is not fully translated yet.",
        "retry": "Retry translation",
        "original": "Show original source (source language)"
      },
      "headers": {
        "task": "Task",
        "criticality": "Criticality",
        "period": "Period",
        "technician": "Technician",
        "materials": "Materials",
        "tools": "Tools",
        "time": "Duration",
        "citations": "Sources",
        "timeDecimal": "Decimal hours",
        "procedure": "Procedure",
        "origin": "Origin"
      },
      "export": {
        "title": "AxiomGO: Maintenance plan",
        "sheetName": "Maintenance plan",
        "equipmentLabel": "Equipment",
        "typeLabel": "Type",
        "noticeLabel": "Notice",
        "inferredDisclaimer": "Usual plan (estimate), NOT from the manufacturer. Generated from similar equipment. Validate before executing.",
        "proceduresTitle": "Procedures"
      },
      "criticality": {
        "A": "Critical A",
        "B": "Grade B",
        "C": "Grade C",
        "inferred": "AI-inferred"
      },
      "unit": {
        "DAYS_one": "{{count}} day",
        "DAYS_other": "{{count}} days",
        "WEEKS_one": "{{count}} week",
        "WEEKS_other": "{{count}} weeks",
        "MONTHS_one": "{{count}} month",
        "MONTHS_other": "{{count}} months",
        "YEARS_one": "{{count}} year",
        "YEARS_other": "{{count}} years",
        "CYCLES_one": "{{count}} cycle",
        "CYCLES_other": "{{count}} cycles"
      },
      "skill": {
        "mechanical": "Mechanical",
        "electrical": "Electrical",
        "instrumentation": "Instrumentation",
        "lubrication": "Lubrication",
        "inspection": "Inspection",
        "general": "General",
        "operator": "Operator"
      },
      "cert": {
        "NR-10": "NR-10",
        "NR-13": "NR-13"
      },
      "toolType": {
        "mechanical": "Mechanical",
        "electrical": "Electrical",
        "measurement": "Measurement",
        "safety": "PPE/Safety",
        "lifting": "Lifting",
        "other": "Other"
      },
      "oemLabel": "OEM",
      "nonOemLabel": "NON-OEM",
      "band": {
        "por_turno": "Per shift",
        "diaria": "Daily",
        "semanal": "Weekly",
        "mensal": "Monthly",
        "trimestral": "Quarterly",
        "semestral": "Semiannual",
        "anual": "Annual",
        "por_hora_operacao": "Per operating hour",
        "por_condicao": "Condition-based"
      },
      "noCadence": "No cadence declared",
      "triggers": {
        "pair": "{{a}} or {{b}}",
        "anyFirst": "whichever comes first",
        "firstService": "First service: {{x}}"
      },
      "expandSteps": "Expand steps",
      "importButton": "Import maintenance plan",
      "exportLabel": "Export",
      "exportXlsx": "Excel (.xlsx)",
      "exportDocx": "Word (.docx)",
      "exportPreparing": "Preparing file…",
      "exportTimeout": "File preparation timed out. No file was generated. Click Excel or Word to try again.",
      "exportError": "Could not generate the file. Please try again.",
      "exportTranslationUnavailable": "The plan could not be fully translated into the selected language. No file was generated. Try again when translation is available.",
      "import": {
        "disabled": "Plan does not meet minimum criteria. Refine your search or register manually."
      },
      "confidence": {
        "overall": "Overall confidence",
        "by_dimension": {
          "period": "Period",
          "technician": "Technician",
          "materials": "Materials",
          "tools": "Tools",
          "duration": "Duration"
        }
      },
      "citation": {
        "title": "Sources for this task"
      },
      "equipmentTypeName": {
        "air_compressor": "Air compressor",
        "boiler": "Boiler",
        "centrifugal_pump": "Centrifugal pump",
        "conveyor_belt": "Conveyor belt",
        "cooling_tower": "Cooling tower",
        "diesel_generator": "Diesel generator",
        "electric_motor": "Electric motor",
        "forklift": "Forklift",
        "heat_exchanger": "Heat exchanger",
        "hydraulic_press": "Hydraulic press",
        "industrial_fan": "Industrial fan",
        "overhead_crane": "Overhead crane",
        "reciprocating_compressor": "Reciprocating compressor",
        "rotary_screw_compressor": "Rotary screw compressor",
        "screw_compressor": "Screw compressor",
        "vacuum_pump": "Vacuum pump"
      },
      "procedureOrigin": "Procedure from {{origin}}, not from the manufacturer",
      "aiFooter": "Suggestion generated by AI from the cited sources. Review before applying: the final decision rests with the responsible engineer.",
      "provenanceTier": {
        "pratica_setor": "industry practice",
        "analogia": "analogy",
        "inferencia": "inference",
        "norma": "technical standard"
      },
      "tasksOmitted_one": "{{count}} plan task is not in this table: the plan exceeded the engine's ceiling.",
      "tasksOmitted_other": "{{count}} plan tasks are not in this table: the plan exceeded the engine's ceiling."
    },
    "rawFindingsHeading": "Manual findings",
    "rawFindingsHint": "Textual evidence extracted from sources (unstructured)",
    "v2": {
      "empty": "No maintenance plan could be structured from available sources.",
      "degraded": "Couldn't structure a complete plan. Manual findings extracted from sources:",
      "findingsTitle": "Raw maintenance findings"
    },
    "cache": {
      "hitChip": "result from {{ago}} ago",
      "refresh": "Refresh",
      "refreshAria": "Refresh result, fetch new data ignoring cache"
    },
    "debug": {
      "pipelineCounters": "Pipeline funnel (admin)",
      "counterKey": "Stage",
      "counterValue": "Count"
    }
  },
  "preventivePlan": {
    "title": "Preventive Plan, draft",
    "empty": "No tasks. Add at least one to save the draft.",
    "headers": {
      "task": "Task",
      "frequency": "Frequency",
      "specialty": "Specialty",
      "cycleStart": "Cycle start",
      "actions": "Actions"
    },
    "unit": {
      "hours": "hours",
      "days": "days",
      "weeks": "weeks",
      "months": "months"
    },
    "specialty": {
      "mechanical": "Mechanical",
      "electrical": "Electrical",
      "instrumentation": "Instrumentation",
      "lubrication": "Lubrication",
      "inspection": "Inspection",
      "general": "General"
    },
    "daysHint": "≈ {{days}}d",
    "addRow": "+ Add task",
    "savePlan": "Save plan",
    "deleteRow": "Delete row",
    "placeholderWarning": "Estimated cadence: review before saving.",
    "entryCard": {
      "title": "How do you want to create the preventive plan?",
      "whichEquipment": "Which equipment is the plan for?",
      "registerEquipment": "Register equipment",
      "import": "Import",
      "webSearch": "Search the Web",
      "manual": "Enter Manually"
    },
    "manualStartHint": "Add each task: what to do, how many days apart, which specialty and which materials. Start with the first one.",
    "addRowHint": "Tip: name it by the verb, 'Replace', 'Inspect', 'Lubricate'.",
    "confirmText": "Plan(s) saved and active: they are already in the schedule.",
    "guidance": {
      "noTeam": "No team registered. Would you like to create a default team?",
      "createDefaultTeam": "Create default team",
      "missingMaterial": "Some materials are not in stock. Would you like to register them now?",
      "registerMaterials": "Register materials"
    },
    "suggestion": {
      "title": "Suggestion: build a preventive plan",
      "withoutPlanSuffix": "equipment without a preventive plan",
      "startA": "Start with the A (critical) ones",
      "startB": "Start with the B ones",
      "startC": "Start with the C ones",
      "manual": "Build manually",
      "dismiss": "Do not remind me for 7 days",
      "close": "Close reminder",
      "headline_one": "1 critical ({{criticality}}) equipment without a preventive plan",
      "headline_other": "{{count}} critical ({{criticality}}) equipment without a preventive plan"
    },
    "suggestionBell": {
      "aria": "Preventive plan suggestions",
      "withoutActivePlan_one": "equipment without a preventive plan",
      "withoutActivePlan_other": "equipment without a preventive plan",
      "draftsAwaitingApproval_one": "draft awaiting approval",
      "draftsAwaitingApproval_other": "drafts awaiting approval"
    }
  },
  "execution": {
    "confirmed": "Confirmed in the system",
    "partial": "Partially recorded",
    "failure": "Not recorded in the system",
    "mismatch": "What was recorded differs from what was requested. Check the items below.",
    "summary": "{{created}} created · {{failed}} failed",
    "status": {
      "created": "Created",
      "failed": "Failed"
    },
    "entity": {
      "work_order": "Work orders",
      "equipment": "Equipment",
      "location": "Locations",
      "maintenance_plan": "Maintenance plans",
      "part": "Parts",
      "goods_receipt": "Goods receipts",
      "notification": "Notifications",
      "material": "Materials",
      "plant": "Plants",
      "team": "Teams",
      "technician": "Technicians",
      "maint_plan": "Maintenance plans",
      "task_list": "Task lists",
      "maintenance_item": "Maintenance items"
    }
  },
  "teamTechnicianBatchReceipt": {
    "title": "Technicians registered",
    "badge": {
      "saved": "SAVED",
      "partial": "{{saved}} OF {{total}} SAVED"
    },
    "status": {
      "saved": "saved"
    },
    "summary": "{{technicians}} technicians · {{teams}} teams created"
  },
  "entityCard": {
    "entity": {
      "WorkOrder": "Work order",
      "Notification": "Notification",
      "WoOperation": "Operation",
      "WoComponent": "Component",
      "MaterialDocument": "Material document",
      "Proposal": "Proposal",
      "Equipment": "Equipment",
      "Location": "Location",
      "Plant": "Plant",
      "Material": "Material",
      "Team": "Team",
      "Technician": "Technician",
      "MaintPlan": "Maintenance plan",
      "MaintTaskList": "Task list",
      "MaintTaskListOperation": "Task list operation",
      "MaintTaskListComponent": "Task list component",
      "MaintenanceItem": "Maintenance item",
      "MaintenanceCycle": "Maintenance cycle",
      "LtpScenario": "Scenario",
      "rotary_screw_compressor": "Rotary screw compressor",
      "unknown": "Equipment"
    },
    "field": {
      "businessId": "Identifier",
      "description": "Technical description",
      "status": "Status",
      "origin": "Source",
      "balanceAfter": "Balance",
      "count": "Count",
      "operationNumber": "Operation",
      "equipmentTag": "Equipment",
      "equipmentName": "Equipment name",
      "plantName": "Plant",
      "taskCount": "Tasks",
      "plannedWoCount": "Planned WOs",
      "period": "Period"
    },
    "unit": {
      "days": "days",
      "hours": "hours",
      "cycles": "cycles"
    },
    "status": {
      "draft": "Draft",
      "open": "Open",
      "active": "Active",
      "in_progress": "In progress",
      "paused": "Paused",
      "completed": "Completed",
      "closed": "Closed",
      "cancelled": "Cancelled",
      "canceled": "Cancelled",
      "deleted": "Deleted",
      "pending": "Pending",
      "approved": "Approved",
      "partial": "Partial",
      "rejected": "Rejected",
      "auto_approved": "Auto-approved",
      "technically_complete": "Technically complete"
    },
    "export": {
      "xlsx": "Export Excel",
      "pdf": "Export Word (.docx)",
      "generating": "Generating file…",
      "error": "Export failed."
    }
  },
  "actions": {
    "approve": "Approve",
    "adjust": "Adjust",
    "dismiss": "Dismiss",
    "yes": "Yes",
    "no": "No"
  },
  "auth": {
    "signIn": "Sign in",
    "signUp": "Sign up",
    "signOut": "Sign out",
    "statusUnavailable": "Access check temporarily unavailable. Retrying.",
    "pendingApproval": {
      "title": "Awaiting approval",
      "message": "Your account is awaiting admin approval. You will be redirected automatically when approved."
    }
  },
  "connection": {
    "signIn": "Sign in",
    "status": {
      "disconnected": "Disconnected",
      "connecting": "Connecting...",
      "connected": "Engine online",
      "reconnecting": "Reconnecting... ({{count}}/{{max}})",
      "degraded": "Fallback mode (REST)",
      "offline": "Offline, messages queued"
    },
    "banner": {
      "degraded": "Unstable connection. Using fallback mode (REST).",
      "offline": "No connection. Messages will be sent once reconnected.",
      "reconnecting": "Reconnecting to the Engine..."
    }
  },
  "team": {
    "previousDeliveryPending": "Revocation of the previous email has not been confirmed yet. Use only this new link.",
    "invitationSent": "Invitation sent to {{email}}. The link is also available below.",
    "pending": {
      "copy": "Copy link",
      "copied": "Link copied."
    },
    "invitationLink": "Acceptance link",
    "shareInvitation": "Invitation created. No email was sent. Share this link only with {{email}}.",
    "invitationExpires": "Valid until {{date}}.",
    "title": "Team",
    "subtitle": "Manage tenant members and roles",
    "member": "Member",
    "role": "Role",
    "status": "Status",
    "statusActive": "Active",
    "statusSuspended": "Suspended",
    "invite": "Invite",
    "inviteTitle": "Invite a new member",
    "email": "Email",
    "selectRole": "Select a role",
    "sendInvite": "Create invitation",
    "inviteSuccess": "Invitation generated",
    "inviteFailed": "Failed to generate invitation",
    "changeRole": "Change role",
    "revoke": "Revoke",
    "confirmRevoke": "Remove {{name}} from this tenant?",
    "revokeSuccess": "Member revoked",
    "revokeFailed": "Failed to revoke",
    "roleChangedSuccess": "Role updated",
    "roleChangeFailed": "Failed to update role",
    "changeRoleTitle": "Change role for {{name}}",
    "newRole": "New role",
    "saveRole": "Save",
    "empty": "No members in this tenant yet",
    "roles": {
      "owner": "Owner",
      "admin": "Administrator",
      "engineer": "Engineer",
      "viewer": "Viewer",
      "field_technician": "Field technician"
    }
  },
  "roles": {
    "title": "Roles and permissions",
    "subtitle": "Configure custom roles for this tenant",
    "system": "System",
    "create": "Create role",
    "createSuccess": "Role created",
    "createFailed": "Failed to create role",
    "delete": "Delete",
    "confirmDelete": "Delete the role {{name}}?",
    "deleteSuccess": "Role deleted",
    "deleteFailed": "Failed to delete role",
    "bindFailed": "Failed to update permission",
    "selectPrompt": "Select a role to edit its permissions",
    "permissionsFor": "{{name}} permissions",
    "systemReadOnly": "System roles cannot be edited",
    "counts": "{{permissions}} permissions · {{members}} members",
    "empty": "No roles defined",
    "createTitle": "Create role",
    "nameLabel": "Role name",
    "descriptionLabel": "Description (optional)",
    "nameRequired": "Enter a name for the role",
    "nameDuplicate": "A role with this name already exists",
    "bindingsUnavailable": "The current permissions for this role could not be loaded; editing is disabled to avoid inconsistency.",
    "bindingsCount": "This role has {{count}} permissions bound"
  },
  "permissions": {
    "matrix": "Permission matrix",
    "resource": "Resource",
    "actions": {
      "create": "Create",
      "read": "Read",
      "update": "Update",
      "delete": "Delete",
      "approve": "Approve",
      "manage": "Manage"
    },
    "resources": {
      "work_order": "Work orders",
      "maint_plan": "Maintenance plans",
      "equipment": "Equipment",
      "user": "Users",
      "role": "Roles",
      "team": "Team"
    }
  },
  "invitation": {
    "title": "You're invited to join {{tenant}}",
    "body": "{{inviter}} invited you to the \"{{role}}\" role as {{email}}. Accept to join.",
    "accept": "Accept invitation",
    "errorTitle": "Invitation unavailable",
    "notFoundBody": "We could not find this invitation. Check the link or ask the person who invited you for a new one.",
    "expiredBody": "This invitation has expired, was already used, or was revoked.",
    "requestNew": "Request a new invitation",
    "requestNewMailtoSubject": "I need a new AxiomGO invitation",
    "goToSignIn": "I already have an account",
    "createAccount": "Create account and accept",
    "alreadyHaveAccount": "Already have an account?",
    "signIn": "Sign in",
    "mismatchTitle": "This invitation is for another account",
    "mismatchBody": "This invitation was sent to {{invited}}. You are signed in as {{current}}.",
    "switchAccount": "Sign in with another account",
    "acceptErrorUsed": "This invitation could not be accepted for this account. Contact your administrator.",
    "mismatchGenericBody": "Your account email does not match the invitation email.",
    "acceptErrorNetwork": "We could not finish right now. Please try again.",
    "retry": "Try again",
    "switchToInvited": "Sign out and sign in with {{email}}",
    "verifyEmailBody": "Verify the invited email on your account before accepting. An unverified address cannot authorize acceptance.",
    "revokedBody": "This invitation was revoked. Ask the administrator for a new invitation.",
    "supersededBody": "This invitation was replaced. Use the most recent invitation link.",
    "usedBody": "This invitation has already been accepted. Sign in with the account that accepted it.",
    "alreadyMemberBody": "This account is already a member of this company. Open the chat to continue."
  },
  "signup": {
    "title": "Create account",
    "description": "Get started free in seconds",
    "submit": "Create account",
    "email": "Email",
    "name": "Name",
    "existing": "Already have an account?",
    "signIn": "Sign in"
  },
  "onboarding": {
    "progress": {
      "phase": {
        "profile": "Your profile",
        "equipment": "Database",
        "plan": "Maintenance plan",
        "team": "Team and materials",
        "done": "All set"
      },
      "eta_one": "≈ {{count}} min left",
      "eta_other": "≈ {{count}} min left",
      "aria_one": "Onboarding progress: phase {{index}} of {{total}}, {{phase}}. About {{count}} minute left.",
      "aria_other": "Onboarding progress: phase {{index}} of {{total}}, {{phase}}. About {{count}} minutes left.",
      "ariaComplete": "Onboarding progress: phase {{index}} of {{total}}, {{phase}}."
    },
    "plan": {
      "title": "Choose your plan",
      "subtitle": "Start free or unlock advanced features for your team.",
      "select": "Choose {{plan}}"
    }
  },
  "billing": {
    "accessDenied": "Only the account owner can view subscriptions and billing. Contact them if you need help here.",
    "title": "Subscription",
    "subtitle": "Current plan: {{plan}}",
    "currentPlan": "Current plan",
    "loading": "Loading…",
    "planNames": {
      "b2c_personal": "Full access"
    },
    "unlimited": "Unlimited",
    "manage": {
      "title": "Manage subscription",
      "description": "Update card, download invoices, or cancel via the Stripe portal.",
      "button": "Open portal"
    },
    "checkout": {
      "noUrl": "Stripe returned no URL, please retry."
    },
    "status": {
      "active": "Active",
      "past_due": "Past due",
      "canceled": "Canceled",
      "trialing": "Trial"
    },
    "quota": {
      "tokens": "Tokens / month",
      "entities": "Entities"
    }
  },
  "usage": {
    "title": "Current usage",
    "tokens": "Tokens",
    "entities": "Entities",
    "tokensQuota": "Tokens · counted toward quota",
    "entitiesQuota": "Entities · counted toward quota",
    "equipment_zero": "{{n}} equipment",
    "equipment_one": "{{n}} equipment",
    "equipment_other": "{{n}} equipment",
    "workOrders_zero": "{{n}} work orders",
    "workOrders_one": "{{n}} work order",
    "workOrders_other": "{{n}} work orders",
    "plans_zero": "{{n}} plans",
    "plans_one": "{{n}} plan",
    "plans_other": "{{n}} plans",
    "actualLine": "Actual consumption this period: {{tokens}} tokens"
  },
  "memory": {
    "updated": "Memory updated",
    "toggle": {
      "on": "Memory ON",
      "off": "Memory OFF",
      "ariaOn": "Memory enabled in this conversation, tap to disable",
      "ariaOff": "Memory disabled in this conversation, tap to enable",
      "titleOn": "The curator is saving learnings from this conversation",
      "titleOff": "Nothing from this conversation is being written to memory"
    },
    "settings": {
      "title": "Operation memory",
      "backToChat": "Back to chat",
      "searchPlaceholder": "Search facts…",
      "export": "Export (JSON)",
      "wipe": "Delete all",
      "wipeConfirm1": "Are you sure?",
      "wipeConfirm2": "Confirm delete all",
      "loading": "Loading…",
      "totalCount": "{{count}} facts in total",
      "listLabel": "Memory facts list",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save",
      "cancel": "Cancel",
      "empty": "No facts in memory yet, they appear as you chat.",
      "confirmDelete": "Delete this fact?",
      "savedToast": "Fact updated.",
      "deletedToast": "Fact removed.",
      "wipedToast": "{{count}} facts removed.",
      "exportedToast": "Export started, check your downloads."
    },
    "lgpd": {
      "description": "These facts were extracted from your conversations by the curator. You can edit, delete or export at any time (Brazilian LGPD Art. 18 / GDPR Art. 20)."
    }
  },
  "trajectory": {
    "repetitions": "{{count}} grouped updates",
    "labels": {
      "pending": "Pending",
      "running": "Running",
      "done": "Done",
      "error": "Error"
    },
    "steps": {
      "searching": "Searching",
      "sources": "Consulting sources",
      "analyzing": "Analyzing data",
      "tools": "Executing action",
      "generating": "Building response",
      "reasoning": "Reasoning"
    },
    "expand": "Expand",
    "collapse": "Collapse",
    "viewAll": "View {{count}} more",
    "expandCard": {
      "expand": "Expand card",
      "expandedBadge": "Card opened full screen",
      "title": {
        "web_search": "Suggested plan, built by Axis",
        "action_cards": "Suggested actions",
        "proposal": "Proposal",
        "form": "Form",
        "kpi": "KPIs",
        "import": "Import",
        "task_materials": "Materials per task",
        "plan_edit": "Maintenance plan: review",
        "resource_allocation": "Resource allocation",
        "equipment_search": "Equipment result",
        "preventive_draft": "Preventive plan: draft"
      }
    }
  },
  "workOrder": {
    "operation": {
      "actualStart": "Actual Start",
      "actualEnd": "Actual End",
      "totalTime": "Total Time",
      "deltaPlannedVsActual": "Δ Planned vs Actual",
      "inProgress": "In progress"
    }
  },
  "artifacts": {
    "open": "Open in panel",
    "openInPanel": "Open in panel",
    "viewMaterials": "View materials",
    "close": "Close panel",
    "empty": "No information available.",
    "unrenderable": "This content couldn't be displayed.",
    "title": {
      "plan": "Maintenance plan",
      "materials": "Materials list",
      "wo": "Work order",
      "import": "Import",
      "citation": "Source",
      "insights": "Insights",
      "schedule": "Schedule"
    },
    "citation": {
      "openLink": "Open original link"
    },
    "materials": {
      "empty": "No materials listed for this plan.",
      "code": "Code",
      "name": "Name",
      "qty": "Qty",
      "unit": "Unit"
    },
    "wo": {
      "status": "Status",
      "priority": "Priority",
      "equipment": "Equipment",
      "location": "Location",
      "team": "Team",
      "plannedStart": "Planned start",
      "plannedEnd": "Planned end",
      "plannedDuration": "Planned duration",
      "operations": "Operations",
      "operationSequence": "Seq."
    },
    "insights": {
      "loadingChart": "Loading chart...",
      "blockFailed": "This block could not be displayed.",
      "gallery": {
        "title": "Axis Insights gallery",
        "description": "Every dashboard block in every state, rendered from fixed samples. Reference for the visual tests; not a product screen.",
        "empty": "No blocks in the gallery yet."
      },
      "panel": {
        "refresh": "Refresh dashboard",
        "refreshPrompt": "Refresh the dashboard \"{{title}}\" with current data",
        "pin": "Pin dashboard"
      },
      "quality": {
        "title": "Data quality notice"
      },
      "kpi": {
        "noValue": "no value: insufficient sample",
        "vs": "vs {{period}}",
        "direction": {
          "up": "up {{delta}}",
          "down": "down {{delta}}",
          "flat": "flat {{delta}}"
        }
      },
      "chart": {
        "retry": "Try again",
        "retryPrompt": "Draw the chart \"{{title}}\" again",
        "failed": "This chart could not be drawn.",
        "aria": "Chart: {{title}}. {{summary}}"
      },
      "table": {
        "sortAsc": "Sort ascending by {{column}}",
        "sortDesc": "Sort descending by {{column}}",
        "page": "Page {{page}} of {{total}}",
        "prev": "Previous page",
        "next": "Next page",
        "rows": "{{shown}} of {{total}} rows"
      },
      "tools": {
        "title": "What the AI ran",
        "params": "Parameters",
        "result": "Result",
        "noParams": "No parameters.",
        "summary": "Result: {{resumo}}",
        "state": {
          "preparing": "preparing",
          "running": "running",
          "done": "done",
          "error": "failed"
        }
      },
      "chips": {
        "aria": "Suggested questions",
        "indicators": "Ready-made questions",
        "indicatorsHint": "Ready-made questions about maintenance indicators and data audit"
      },
      "report": {
        "severity": {
          "high": "high",
          "medium": "medium",
          "info": "info"
        },
        "detections": "Detections",
        "method": "Method: {{name}} · n={{n}}",
        "trendNotDate": "a trend, not a date forecast"
      }
    }
  },
  "citations": {
    "tooltip": {
      "viewSource": "Open in panel"
    },
    "unavailable": "Source unavailable",
    "loading": "Loading source…",
    "error": "Could not load the source.",
    "retry": "Try again",
    "typeLabel": {
      "doc": "Document",
      "wo": "Work order",
      "norma": "Technical standard",
      "equip": "Equipment"
    },
    "wo": {
      "unavailable": "Work order unavailable right now.",
      "notFound": "Work order not found."
    }
  },
  "plans": {
    "export": {"plan": "Plan", "equipment": "Equipment", "description": "Description", "strategy": "Strategy", "interval": "Interval", "nextDue": "Next due", "tasks": "Tasks", "origin": "Plan origin", "sequence": "Sequence", "instruction": "Instruction", "duration": "Duration (min)", "notRecorded": "Not recorded", "plansSheet": "Plans", "tasksSheet": "Tasks",
      "units": {"days": "days", "hours": "hours", "km": "km", "cycles": "cycles"},
      "origins": {"user": "User", "ai_proposal": "AI proposal", "ai_auto": "Automatic AI"}, "source": "Source reference", "page": "Page", "citation": "Source quote", "grounding": "Grounding", "groundingLabels": {"verified": "Verified quote", "ai_unverified": "Unverified AI suggestion"}},
    "cadence": {
      "unavailable": "Frequency unavailable",
      "notScheduledAutomatically": "No automatic scheduling"
    },
    "bulk": {
      "trigger": "Activate inactive plans ({{count}})",
      "groupLabel": "Bulk plan activation",
      "reviewTitle_one": "Activate {{count}} inactive plan from this list?",
      "reviewTitle_other": "Activate {{count}} inactive plans from this list?",
      "reviewBody": "Each plan goes through the normal activation, with the same validations and permissions. Plans that are already active are not changed.",
      "confirm": "Confirm activation",
      "cancel": "Cancel",
      "progress": "Activating: {{done}} of {{total}}",
      "resultAll_one": "The plan was activated.",
      "resultAll_other": "All {{count}} plans were activated.",
      "resultMixed": "{{confirmed}} activated, {{refused}} refused, {{pending}} unconfirmed.",
      "refused": "{{tag}}: refused. {{reason}}",
      "pending": "{{tag}}: unconfirmed. Check before trying again.",
      "retry": "Check and retry ({{count}})",
      "dismiss": "Close"
    },
    "title": "Preventive Plans",
    "filterPlaceholder": "Filter by tag or number (PLA-…)",
    "strategyFilterLabel": "Filter by strategy",
    "statusFilterLabel": "Filter by status",
    "allStrategies": "All strategies",
    "allStatuses": "All",
    "activeOnly": "Active",
    "inactiveOnly": "Inactive",
    "noResults": "No plans found.",
    "taskCount_zero": "0 tasks",
    "taskCount_one": "{{count}} task",
    "taskCount_other": "{{count}} tasks",
    "tasksUnknown": "… tasks",
    "tasksHeading": "Tasks",
    "tasksEmpty": "Plan has no tasks, incomplete.",
    "detailTitle": "Plan detail",
    "detailError": "Could not load the plan detail.",
    "field": {
      "strategy": "Strategy",
      "interval": "Interval",
      "origin": "Origin",
      "active": "Active"
    },
    "col": {
      "plan": "Plan",
      "equipment": "Equipment",
      "description": "Description",
      "interval": "Interval",
      "nextDue": "Next due",
      "tasks": "Tasks"
    }
  },
  "horizon": {
    "title": "Preventive horizon (52 weeks)",
    "subtitle": "Active plans per ISO week. Read-only.",
    "empty": "No plans scheduled in the horizon.",
    "weekDetail": "Week {{week}}, {{count}} plan(s)"
  },
  "preventiveDue": {
    "title": "Preventive plans due",
    "summary": "{{count}} plan(s) due in the next {{days}} days.",
    "cta": "Review and generate WO",
    "dismiss": "Dismiss"
  },
  "validator": {
    "fallback": {
      "phantomTag": "I could not safely confirm the equipment referenced in this response. Please refine your query, for example, provide a specific tag, plant, or location, and try again.",
      "enforceExhausted": "I could not produce a reliable answer to this request right now. Try rephrasing it or contact support."
    }
  },
  "voice": {
    "errors": {
      "notSupported": "Voice command is not supported in this browser.",
      "notAllowed": "Microphone permission denied.",
      "noSpeech": "I did not hear anything. Please try again.",
      "audioCapture": "Could not access the microphone.",
      "aborted": "Voice capture interrupted.",
      "network": "Network error during speech recognition.",
      "serviceNotAllowed": "Voice service unavailable.",
      "languageNotSupported": "Language not supported for voice.",
      "synthesisFailed": "Failed to narrate the response.",
      "unknown": "Unknown voice error."
    },
    "provenance": {
      "suppressedUnbackedIdentifiers": "Some unverified identifiers were omitted from narration."
    },
    "listening": "Stop and send",
    "pushToTalk": "Speak a command",
    "stopNarration": "Stop narration",
    "permissionLost": "Microphone permission lost",
    "disambiguateOp": "Which operation? {{options}}",
    "enable": "Enable voice",
    "disable": "Disable voice",
    "narrationTruncated": "Narration shortened. See the full reply on screen.",
    "disabledMeeting": "Microphone unavailable while a meeting is being recorded"
  },
  "equipmentRegistration": {
    "commit": {
      "saving": "Saving…",
      "offline": "No connection to the server. Nothing has been saved yet.",
      "tagTaken": "The TAG {{tag}} already exists in this plant. Choose another one.",
      "stale": "The data changed, please review this step.",
      "forbidden": "Your profile is not allowed to register equipment.",
      "planLimit": "You have reached the equipment limit of your plan.",
      "refusedTitle": "Registration not saved",
      "savedTitle": "Registration saved",
      "wait": "The server asked for a pause. Try again in {{segundos}} s.",
      "waitShort": "Too many attempts in a row. Wait a moment and try again.",
      "syncFailed": "I couldn't save the registration progress before your message. It is still in the field; try sending it again."
    },
    "identity": {
      "title": "What are the equipment's manufacturer, model and description?",
      "hint": "We suggest a tag from the manufacturer and model, you can accept it or type your own in the next step.",
      "manufacturerPlaceholder": "Manufacturer (e.g. Krones)",
      "modelPlaceholder": "Model (e.g. Modulfill VFS)",
      "descriptionPlaceholder": "Full description (e.g. screw compressor in the utilities room)",
      "titleSeeded": "Confirm the equipment manufacturer and model.",
      "hintSeeded": "We brought over the manufacturer and model you already provided. Review, adjust if needed and confirm; the tag comes in the next step.",
      "submitSeeded": "Confirm"
    },
    "intro": {
      "title": "Shall we register this equipment?",
      "body": "To register {{manufacturer}} {{model}} I need a Plant and a Location.",
      "requirements": "I will need the plant and the location where it is installed.",
      "continue": "Continue"
    },
    "plant": {
      "title": "Which plant is this equipment in?",
      "label": "Equipment plant",
      "loading": "Loading plants...",
      "error": "Error loading plants.",
      "newPlant": "Create new plant",
      "newPlantHint": "Provide the name of the new plant. The code can be generated automatically.",
      "autoCodeLabel": "Generate code automatically",
      "codePlaceholder": "Code (e.g. PLT-01)",
      "namePlaceholder": "Plant name",
      "countryPlaceholder": "Country (optional)",
      "currencyPlaceholder": "Currency",
      "createPlant": "Create plant",
      "errorForbidden": "No permission to list plants. Create a new one below."
    },
    "location": {
      "title": "And where in the plant is it?",
      "label": "Location within the plant",
      "loading": "Loading locations...",
      "error": "Error loading locations.",
      "noLocations": "This plant has no locations yet. Create the first one below.",
      "newLocation": "Create new location",
      "autoCodeLabel": "Generate code automatically",
      "codePlaceholder": "Code (e.g. LOC-A)",
      "descriptionPlaceholder": "Description (optional)",
      "createLocation": "Create location"
    },
    "tag": {
      "title": "How would you like to identify it (the tag)?",
      "label": "Identification (TAG)",
      "hint": "The tag uniquely identifies the equipment in your plant.",
      "autoPreview": "Suggested tag: {{tag}}",
      "generateAuto": "Generate automatically",
      "haveTag": "I already have a tag",
      "placeholder": "e.g. KRN-001",
      "submit": "Use this tag",
      "sequenceOnConfirm": "(generated on confirm)"
    },
    "criticality": {
      "title": "How critical is it: A, B or C?",
      "label": "Criticality (A, B or C)",
      "hint": "Sets the maintenance priority. Default: C (Normal).",
      "optionA": "Critical",
      "descA": "If it stops, production stops",
      "optionB": "Important",
      "descB": "If it stops, part of production is affected",
      "optionC": "Normal",
      "descC": "No immediate impact on production",
      "confirm": "Confirm criticality"
    },
    "confirming": {
      "title": "Does everything look right to register?",
      "equipment": "Equipment: {{manufacturer}} {{model}}",
      "tag": "Tag: {{tag}}",
      "criticality": "Criticality: {{criticality}}",
      "plant": "Plant (existing): {{name}}",
      "plantFallback": "already selected plant",
      "newPlant": "New plant: {{code}} - {{name}}",
      "location": "Location (existing): {{name}}",
      "locationFallback": "already selected location",
      "newLocation": "New location: {{code}}",
      "confirm": "Confirm registration"
    },
    "summary": {
      "start": "Register equipment: {{value}}.",
      "startBare": "Register equipment.",
      "equipment": "Equipment: {{value}}.",
      "plant": "Plant: {{value}}.",
      "plantBare": "Plant selected.",
      "newPlant": "New plant: {{value}}.",
      "location": "Location: {{value}}.",
      "locationBare": "Location selected.",
      "newLocation": "New location: {{value}}.",
      "tagAuto": "Tag generated automatically.",
      "tagManual": "Manual tag: {{value}}.",
      "criticality": "Criticality: {{value}}.",
      "confirm": "Confirm equipment registration.",
      "cancel": "Cancel equipment registration.",
      "back": "Back to the previous step.",
      "generic": "Equipment registration action."
    },
    "done": {
      "title": "Equipment registered successfully.",
      "railBody": "Plant, location and equipment registered.",
      "railBodyLocationEquipment": "New location registered in the existing plant.",
      "railBodyEquipmentOnly": "In the plant and location that already existed.",
      "railQuestion": "You decide the next step. Do you want to build the preventive plan for the equipment or open a corrective work order for a current failure?",
      "actions": {
        "plan": {
          "label": "Create preventive plan",
          "message": "Quero montar um plano de manutenção preventiva para o equipamento {{tag}}"
        },
        "corrective": {
          "label": "Open corrective work order",
          "message": "Open corrective work order for equipment {{tag}}"
        },
        "view": {
          "label": "View equipment",
          "message": "Mostrar o equipamento {{tag}}"
        }
      }
    },
    "cancelled": {
      "title": "Registration cancelled",
      "body": "Nothing was saved. You can start over whenever you want."
    },
    "common": {
      "back": "Back",
      "cancel": "Cancel registration",
      "retry": "Try again"
    }
  },
  "equipmentSearch": {
    "form": {
      "equipmentType": "Equipment type",
      "equipmentTypePlaceholder": "E.g. Compressor",
      "manufacturer": "Manufacturer",
      "manufacturerPlaceholder": "E.g. Atlas Copco",
      "model": "Model",
      "modelPlaceholder": "E.g. GA37",
      "submit": "Search manufacturer plan"
    },
    "card": {
      "title": "My equipment",
      "count": "{{count}} equipment",
      "count_one": "{{count}} equipment",
      "count_other": "{{count}} equipment",
      "empty": "No equipment found.",
      "hasMore": "Showing {{returned}} of {{total}}.",
      "listMoreAria": "{{label}} (page {{page}})",
      "viewHistory": "View history",
      "searchManufacturer": "Search data on the WEB",
      "viewHistoryQuery": "Histórico do equipamento {{tag}}",
      "searchManufacturerQuery": "Me fale do {{equipment}}",
      "createWorkOrder": "Create work order",
      "details": "Equipment details"
    },
    "criticality": {
      "A": "A · Critical",
      "B": "B · Important",
      "C": "C · Normal"
    },
    "optionalSuffix": " (optional)"
  },
  "planDetail": {
    "active": "Active",
    "inactive": "Inactive",
    "strategy": "Strategy",
    "interval": "Interval",
    "nextDue": "Next due",
    "counts": "Tasks / materials",
    "tasksHeading": "Tasks",
    "tasksEmpty": "Plan has no tasks.",
    "materialsHeading": "Materials",
    "strategies": {
      "time_based": "By time",
      "usage_based": "By usage",
      "condition_based": "By condition",
      "predictive": "Predictive"
    }
  },
  "notificationDetailing": {
    "resources": {
      "team": "Team",
      "specialty": "Specialty (from team)",
      "technician": "Technician",
      "select": "Select",
      "loadError": "Could not load teams or technicians. Try again."
    },
    "missingLabel": "Still to fill in:",
    "plannedStart": "Planned date",
    "plannedStartTime": "Time (optional)",
    "timeWillBeAssumed": "No time given: the system assumes the start of the workday and shows the time for you to confirm.",
    "timeAssumed": "Assumed time: start of the workday ({{time}}). Confirm or change it before saving.",
    "errors": {
      "sendFailed": "Could not send. Check your connection and try again.",
      "descriptionRequired": "Enter an operation description; spaces alone are not valid.",
      "pastDate": "Choose a future date.",
      "invalidDate": "Invalid date."
    },
    "operationTitle": "Operation {{sequence}}",
    "operationsField": "Operations",
    "missingInOperation": "{{field}} (operation {{sequence}})",
    "description": "Description",
    "duration": "Planned time",
    "durationUnit": "Unit",
    "unit": {
      "MINUTES": "Minutes",
      "HOURS": "Hours",
      "DAYS": "Days"
    },
    "technicians": "Number of technicians",
    "condition": "Installation condition",
    "conditionPlaceholder": "Not set",
    "systemCondition": {
      "OPERATING": "Machine running",
      "PARTIAL_STOP": "Partial stop",
      "FULL_STOP": "Full stop"
    },
    "newOperation": "New operation",
    "addOperation": "Add operation",
    "save": "Save and exit",
    "stop": "Stop work order"
  },
  "materialConsumption": {
    "title": "Material consumption",
    "summary_one": "{{count}} material issued",
    "summary_other": "{{count}} materials issued",
    "summaryPending_one": "{{count}} reservation not yet issued",
    "summaryPending_other": "{{count}} reservations not yet issued",
    "expand": "Show materials",
    "collapse": "Collapse",
    "operation": "Operation {{number}}",
    "pendingTitle": "Reserved, not yet issued"
  },
  "operationsPanel": {
    "materials": {
      "planned": "Planned materials",
      "unlinked": "No linked operation",
      "unavailable": "Linked operation unavailable"
    },
    "defaultInspection": "Inspect and diagnose the reported equipment failure",
    "plannedTime": "Planned time: {{time}}",
    "plannedStart": "Planned start: {{date}}",
    "technicianLabel": "Technician: {{name}}",
    "plannedDuration": {
      "hours": "{{hours}} h",
      "minutes": "{{minutes}} min",
      "hoursMinutes": "{{hours}} h {{minutes}} min"
    },
    "systemConditionLabel": "System condition: {{condition}}",
    "systemCondition": {
      "OPERATING": "Machine running",
      "PARTIAL_STOP": "Partial stop",
      "FULL_STOP": "Full stop"
    },
    "actions": {
      "assignTechnician": "Assign technician",
      "addMaterial": "Add material",
      "addOperation": "Add more operations",
      "closeOrder": "Close work order",
      "reviewClosure": "Review work order closure",
      "confirmMaterialConsumption": "Confirm material consumption",
      "start": "Start",
      "pause": "Pause",
      "resume": "Resume",
      "finishOperation": "Finish operation"
    },
    "missingLabel": "Missing: {{items}}",
    "missing": { "technician": "technician", "material_optional": "material (optional)" },
    "closeOperation": {
      "title": "Operation {{operation}}: what was done?",
      "cause": "Cause (ISO 14224)",
      "selectCause": "Select a cause",
      "executedBy": "Performed by (optional)",
      "executedByRequired": "Performed by (required)",
      "team": "Team: {{name}}",
      "activeTime": "Active time {{time}} · calculated, no typing",
      "openingTime": "Active time when opening completion {{time}}",
      "note": "What was done",
      "noteMinimum": "{{count}}/{{minimum}} characters (minimum)",
      "noteCount": "{{count}} characters",
      "back": "Back",
      "submit": "Close operation {{operation}}"
    },
    "pending": {
      "title": "The operation is still open.",
      "description": "What would you like to do?"
    },
    "reservedMaterial": {
      "title": "Review reserved materials",
      "description": "Check the reserved materials and selected quantities."
    },
    "closeOrder": {
      "title": "Work order review",
      "note": "What was done",
      "description": "Check the work order and its operations before continuing."
    },
    "closed": { "title": "Work order closed" }
  },
  "workOrderDetail": {
    "planning": {
      "duration": "Operation duration",
      "plannedMinutes": "Planned time",
      "team": "Planned team",
      "specialty": "Specialty",
      "technician": "Planned technician",
      "performedBy": "Recorded execution",
      "unitUnknown": "{{value}} (unit not provided)",
      "units": {
        "HOURS": "{{value}} h",
        "MINUTES": "{{value}} min",
        "DAYS": "{{value}} days"
      }
    },
    "organization": {
      "condition": "Condition",
      "plant": "Plant",
      "team": "Team",
      "noTeam": "No team",
      "unknown": "Not specified"
    },
    "completionActions": {
      "open": {
        "label": "New corrective work order",
        "message": "Open corrective work order for equipment {{tag}}"
      },
      "view": {
        "label": "View equipment",
        "message": "Show equipment {{tag}}"
      },
      "plan": {
        "label": "Generate preventive plan",
        "message": "I want to create a preventive maintenance plan for equipment {{tag}}"
      }
    },
    "priority": "Priority",
    "type": "Type",
    "scheduledStart": "Scheduled start",
    "scheduledEnd": "Scheduled end",
    "numberColumn": "WO",
    "updatedAt": "Updated at",
    "descriptionHeading": "Description",
    "notificationHeading": "Linked notification",
    "operationsHeading": "Operations",
    "operationsEmpty": "Work order has no operations.",
    "componentsHeading": "Components",
    "status": {
      "draft": "Draft",
      "planned": "Planned",
      "in_progress": "In progress",
      "released": "Released",
      "technically_complete": "Technically complete",
      "completed": "Completed",
      "canceled": "Cancelled",
      "desconhecido": "Unknown status"
    },
    "opPausedPhrase": "Operation {{number}} paused",
    "opStatus": {
      "pending": "Pending",
      "in_progress": "In progress",
      "completed": "Completed",
      "paused": "Paused",
      "cancelled": "Cancelled",
      "desconhecido": "Unknown status"
    },
    "preventiveNormalPriority": "Normal",
    "priorityLevel": {
      "critical": "Emergency",
      "high": "Urgent",
      "medium": "Important",
      "low": "Low",
      "desconhecido": "Unknown priority"
    },
    "unit": {
      "pc_one": "pc",
      "pc_other": "pcs",
      "lt": "L",
      "kg": "kg",
      "m": "m"
    },
    "woType": {
      "corrective": "Corrective",
      "preventive": "Preventive",
      "predictive": "Predictive",
      "improvement": "Improvement",
      "desconhecido": "Unknown type"
    }
  },
  "planEdit": {
    "frequencySecondary": "or {{value}} {{unit}} (whichever comes first)",
    "frequencySuggested": "Suggestion read from the manual: check and confirm, or edit.",
    "frequencySuggestedInferred": "Months estimated from the hours (inference): check and confirm, or edit.",
    "frequencyUnrecognized": "Frequency pending. Set it",
    "definirFrequencia": "Set frequency",
    "definirEspecialidade": "Set specialty",
    "specialtyNotInformed": "Not provided",
    "bulkSpecialty": {
      "label": "Specialty for every blank row",
      "apply": "Apply to the blank ones"
    },
    "frequencyConditionBased": "Condition-based task: the source gives no fixed interval. Set how often it should be checked.",
    "sourceFrequency": "Frequency in the original plan",
    "title": "Maintenance Plan: review",
    "col": {
      "index": "#",
      "tarefa": "Task",
      "inicioCiclo": "Cycle Start",
      "frequencyUnit": "Frequency unit",
      "origem": "Source"
    },
    "confirm": "Confirm plan",
    "cancel": "Back",
    "error": {
      "descriptiveFrequencyInvalid": "The received descriptive frequency could not be validated.",
      "dateInvalid": "Invalid date, use dd/mm/yyyy",
      "unitRequired": "Pick the frequency unit",
      "frequencyPositive": "The frequency must be a number greater than zero",
      "required": "Required"
    },
    "freqUnit": {
      "HOURS": "hours",
      "DAYS": "days",
      "WEEKS": "weeks",
      "MONTHS": "months",
      "YEARS": "years",
      "CYCLES": "cycles"
    },
    "replicateDate": "Copy this date to the other tasks",
    "replicate": "Replicate",
    "taskPlaceholder": "Describe the task",
    "duplicateBadge": "Duplicate task",
    "dataNoPassado": "Starts in the past",
    "requiredField": "required",
    "requiredCount": "{{count}} row(s) with required fields left blank",
    "requiredJump": "Go to the first one",
    "bulkDate": {
      "label": "Cycle start for every row",
      "apply": "Apply to the blank ones"
    },
    "empty": {
      "linha": "No tasks yet. Add them below, or go back and ask for the plan search.",
      "confirmBloqueado": "There is no task to confirm"
    },
    "source": {
      "page": "page {{page}}",
      "pageAria": "Manual page {{page}}",
      "quoteSummary": "Manual excerpt"
    },
    "provenance": {
      "fabricante": {
        "rotulo": "Manufacturer",
        "ajuda": "Extracted from the manufacturer manual by Axis. Check the original document."
      },
      "cliente": {
        "rotulo": "Your plan",
        "ajuda": "Task from the plan you already use, as written in your spreadsheet."
      },
      "analogia": {
        "rotulo": "Analogy",
        "ajuda": "From the manufacturer documentation of another model with the same architecture. Review before applying."
      },
      "pratica_setor": {
        "rotulo": "Industry practice",
        "ajuda": "Established practice for this equipment class, not manufacturer documentation. Review before applying."
      },
      "inferencia": {
        "rotulo": "Machine-inferred",
        "ajuda": "Derived from the machine architecture, not manufacturer documentation. Review before applying."
      },
      "norma": {
        "rotulo": "Technical standard",
        "ajuda": "Required by a technical standard (NR, ISO) for this equipment type, not by manufacturer documentation. Check the cited standard before applying."
      }
    }
  },
  "teamRoster": {
    "title": "Team Registration",
    "col": {
      "name": "Name",
      "role": "Role",
      "email": "Email",
      "personnelNumber": "Personnel #",
      "specialties": "Specialties"
    },
    "role": {
      "placeholder": "Select",
      "mechanic": "Mechanic",
      "electrician": "Electrician",
      "instrumentist": "Instrumentist",
      "electromechanic": "Electromechanic",
      "lubricator": "Lubricator",
      "welder": "Welder",
      "boilermaker": "Boilermaker",
      "refrigeration_technician": "Refrigeration & HVAC Technician",
      "automation_technician": "Automation Technician",
      "predictive_analyst": "Predictive Analyst (Vibration & Thermography)",
      "civil_maintainer": "Civil Maintenance Technician",
      "hydraulics_pneumatics_technician": "Hydraulics & Pneumatics Technician",
      "operator": "Operator",
      "planner": "Planner (PCM)",
      "supervisor": "Supervisor",
      "helper": "Maintenance Helper"
    },
    "specialtiesPlaceholder": "Comma-separated",
    "addRow": "Add technician",
    "removeRow": "Remove row",
    "confirm": "Finish team",
    "error": {
      "roleRequired": "Choose the technician's role"
    }
  },
  "materialsInventory": {
    "title": "Materials Inventory",
    "col": {
      "code": "Material Code",
      "description": "Material Description",
      "quantity": "Enter Inventory",
      "unit": "Unit"
    },
    "addRow": "Add material",
    "removeRow": "Remove row",
    "confirm": "Finish materials"
  },
  "alerts": {
    "correctiveEmergency": {
      "title": "Emergency corrective maintenance on {{equipment}}",
      "titleWithoutEquipment": "Emergency corrective maintenance reported",
      "body": "Emergency corrective maintenance was opened for equipment {{equipment}}.",
      "bodyWithoutEquipment": "Emergency corrective maintenance was opened.",
      "report": "Report: {{description}}",
      "note": "Notification {{number}}.",
      "action": "The team needs to assess the shutdown now."
    },
    "bell": {
      "aria": "Notifications",
      "ariaWithCount_one": "Notifications, {{count}} unread",
      "ariaWithCount_other": "Notifications, {{count}} unread",
      "title": "Notifications"
    },
    "panel": {
      "aria": "Notifications panel",
      "title": "Notifications"
    },
    "markRead": "mark as read",
    "markAllRead": "mark all as read",
    "beyondPage_one": "+{{count}} unread beyond this list",
    "beyondPage_other": "+{{count}} unread beyond this list",
    "empty": "Nothing here.",
    "loading": "Loading notifications...",
    "retry": "Try again",
    "error": {
      "load": "Could not load your notifications."
    }
  },
  "osNotification": {
    "alertBody": "Tap to open AxiomGO.",
    "planReadyTitle": "Maintenance plan ready",
    "planReadyBody": "The plan for {{label}} is ready for review."
  },
  "nps": {
    "pulse": {
      "title": "How was creating this plan?",
      "subtitle": "From 0 to 10, how likely are you to recommend AxiomGO to another maintenance professional?",
      "scoreGroupLabel": "Score from 0 to 10",
      "scoreLabel": "Score {{score}}",
      "anchorLow": "Would not recommend",
      "anchorHigh": "Would strongly recommend",
      "commentLabel": "Optional comment",
      "commentPlaceholder": "Want to tell us why? (optional)",
      "sending": "Sending your answer...",
      "error": "We could not record your answer. Try sending it again.",
      "submit": "Send answer",
      "dismiss": "Not now"
    }
  },
  "taskMaterials": {
    "stockSuggestionNotice": "Suggested balances use the combined plan demand by code and unit. They are not confirmed physical stock. Review or clear the value; nothing is saved before confirmation.",
    "stockSuggested": "Plan demand · suggestion",
    "stockDeclared": "Entered value",
    "stockBlocked": "No suggestion: this code appears in several places with a missing or invalid quantity, a different or unknown unit, or repeated in the same task. Fix it or enter the balance.",
    "col": {
      "code": "Code",
      "description": "Description",
      "quantity": "Qty.",
      "unit": "Unit",
      "saldoInicial": "Opening balance"
    },
    "semMaterial": "No materials in this task.",
    "addRow": "+ add material to this task",
    "deleteRow": "Delete",
    "regiao": "Materials by task",
    "invalidUnit": "Choose a supported unit: {{units}}.",
    "defineUnit_one": "Set the unit for {{count}} material to update everything ({{units}}).",
    "defineUnit_other": "Set the unit for {{count}} materials to update everything ({{units}})."
  },
  "materialPicker": {
    "title": "Which materials will operation {{operation}} use?",
    "search": "Search code, description, manufacturer or part",
    "searchServer": "Search server",
    "shown": "{{shown}} of {{total}} shown",
    "stock": "In stock: {{count}} {{unit}}",
    "noStock": "No stock available",
    "quantity": "Quantity to reserve",
    "selected": "{{count}} materials selected",
    "add": "Add {{count}} materials",
    "selected_one": "{{count}} material selected",
    "selected_other": "{{count}} materials selected",
    "add_one": "Add {{count}} material",
    "add_other": "Add {{count}} materials",
    "expand": "Open details",
    "collapse": "Collapse details",
    "expandAll": "Open all",
    "collapseAll": "Collapse all",
    "balance": "Balance",
    "reserved": "Reserved",
    "available": "Available",
    "empty": "No materials registered in inventory.",
    "noResults": "Nothing found for this search.",
    "register": "Register more materials",
    "registerMessage": "I want to register more materials."
  },
  "importFlow": {
    "title": "Spreadsheet import",
    "refusal": "Still unresolved: {{field}}",
    "choosingPath": {
      "body": "Two paths: send your own spreadsheet, or download the template files to fill in and come back later."
    },
    "awaitingFile": {
      "body": "Send the spreadsheet as an attachment. I accept .xlsx, .xls and .csv up to 50 MB."
    },
    "analyzing": {
      "body": "Reading your spreadsheet..."
    },
    "reviewing": {
      "body": "Review what I understood from each sheet and resolve the pending items before confirming."
    },
    "importing": {
      "body": "Importing your data...",
      "retrying": "Hit a bump, retrying..."
    },
    "completed": {
      "body": "Import finished: {{imported}} items are in."
    },
    "completedWithPending": {
      "body": "Import finished with pending rows: {{imported}} made it and {{failed}} rows were left out."
    },
    "failed": {
      "body": "I could not import anything: {{reason}}. Nothing was saved."
    },
    "canceled": {
      "body": "Import canceled. Nothing was saved.",
      "templates": "Template files are ready. Fill them in and come back to send."
    },
    "expired": {
      "body": "This import sat idle for too long and expired. Send the spreadsheet again."
    },
    "sheet": {
      "suggested": "looks like {{entity}},",
      "unrecognized": "not recognized,",
      "pending": "awaiting your decision",
      "accepted": "will be imported",
      "ignored": "left out",
      "expired": "decision expired"
    },
    "actions": {
      "chooseImport": "Send spreadsheet",
      "chooseTemplates": "Download templates",
      "resolvePending": "Register what is missing",
      "replaceFile": "Replace spreadsheet",
      "cancel": "Cancel"
    }
  },
  "resourceAllocation": {
    "suggestion": {
      "specialty_match": "suggested: declared skill",
      "role_match": "suggested: by team role",
      "general_fallback": "suggested: covers general work",
      "no_match": "no technician with this specialty",
      "user_edit": "your choice"
    },
    "suggestionAria": "Where this assignment came from"
  },
  "teamPicker": {
    "title": "Which team handles this order?",
    "emptyNoCreate": "No team is registered and you cannot add one. Ask an administrator.",
    "areaFilter": "Filter by area",
    "allAreas": "All",
    "openOrders_zero": "{{count}} open orders",
    "openOrders_one": "{{count}} open order",
    "openOrders_other": "{{count}} open orders",
    "empty": "No team is registered for this plant yet.",
    "register": "Add team",
    "confirm": "Confirm team",
    "form": {
      "name": "Team name",
      "area": "Area",
      "nameHint": "E.g. Mechanics Shift A",
      "areaHint": "E.g. Hydraulics",
      "areaPlaceholder": "Choose an area",
      "cancel": "Cancel",
      "submit": "Add and choose"
    }
  },
  "technicianPicker": {
    "title": "Who will perform operation {{operation}}?",
    "teamFilter": "Filter by team",
    "allTeams": "All",
    "search": "Search technicians",
    "openOrders_one": "{{count}} open work order",
    "openOrders_other": "{{count}} open work orders",
    "selected_one": "{{count}} technician selected",
    "selected_other": "{{count}} technicians selected",
    "register": "Register new technician",
    "form": {
      "name": "Name",
      "role": "Role",
      "team": "Team",
      "noTeam": "No team",
      "email": "Email (optional)",
      "personnelNumber": "Personnel # (optional)",
      "emailInvalid": "Enter a valid email address or leave it blank.",
      "cancel": "Cancel",
      "submit": "Register and select"
    },
    "assign_one": "Assign {{count}} technician",
    "assign_other": "Assign {{count}} technicians"
  },
  "confirmDialog": {
    "title": "Confirm action",
    "confirm": "Confirm"
  },
  "auris": {
    "menu": {
      "gravarReuniao": "Record meeting"
    },
    "modal": {
      "titulo": "Record meeting",
      "aviso": "The device microphone will pick up the conversation in the room. The audio is not stored: only the transcript is kept, and it is what becomes the minutes.",
      "participantes": "How many people are in the room?",
      "assunto": "Subject (optional)",
      "aceite": "I told the people in the room that the conversation will be recorded.",
      "gravar": "Start recording"
    },
    "barra": {
      "gravando": "Recording the meeting. The audio is not stored.",
      "encerrando": "Closing and generating the minutes...",
      "blocos": "{{count}} segments sent",
      "furada": "One segment did not upload. The recording will be incomplete.",
      "interrompida": "Recording stopped on the server. What was already said is saved; the rest is not.",
      "continuar": "Continue in a new recording",
      "encerrar": "Stop"
    },
    "card": {
      "titulo": "Meeting minutes",
      "parcial": "The recording was interrupted before the end. Part of the conversation was not captured.",
      "parcialAosMinutos": "Partial minutes: recording interrupted at {{minutos}} minutes. Part of the conversation was not captured.",
      "parcialAoMinuto": "Partial minutes: recording interrupted at 1 minute. Part of the conversation was not captured.",
      "parcialMenosDeUmMinuto": "Partial minutes: recording interrupted before 1 minute. Part of the conversation was not captured.",
      "confiancaBaixa": "Some segments had poor audio and may contain transcription errors.",
      "listaVazia": "Nothing in this list.",
      "aprovarAta": "Approve minutes",
      "aprovarItem": "Approve item",
      "efetivarItem": "Turn into work order",
      "dono": "Owner: {{nome}}",
      "donoPorApelido": "Owner: {{nome}} (resolved by nickname)",
      "lista": {
        "decisoes": "Decisions",
        "tarefas": "Tasks",
        "pendencias": "Open points",
        "propostas": "Proposals"
      },
      "ataNaoSaiu": "The meeting was saved, but the minutes could not be generated right now. The transcript is kept and can be processed again."
    },
    "impedimento": {
      "item_needs_attestation": "The segment backing this item still needs to be attested from memory.",
      "item_has_no_evidence": "This item has no segment of the conversation backing it.",
      "item_evidence_stale": "The segment backing this item changed after the review.",
      "non_objection_needs_confirmation": "It still needs confirming that nobody objected.",
      "item_not_in_review": "This item is not under review."
    },
    "recusa": {
      "transcription_provider_unconfigured": "Transcription is not configured on this account. The meeting cannot be recorded right now, please tell the administrator.",
      "transcription_provider_unavailable": "The transcription service did not respond. Try again in a few minutes.",
      "consent_not_recorded": "The consent record could not be saved. Without it, the microphone stays closed.",
      "notice_attestation_missing": "Say how many people are in the room before recording.",
      "notice_text_unresolved": "The recording notice on this account is incomplete. Please tell the administrator.",
      "retention_policy_missing": "This account has no retention period set. The meeting cannot start.",
      "meeting_wrong_state": "This meeting has already been closed.",
      "chunk_out_of_session": "The recording was interrupted on the server. What was already spoken is saved, the rest is not.",
      "meeting_duration_exceeded": "The meeting went past the maximum length and was closed.",
      "transcription_session_closed": "The transcription session was already closed.",
      "item_not_in_review": "This item is not under review.",
      "item_already_effectuated": "This item has already been turned into a work order.",
      "item_needs_attestation": "The segment for this item still needs to be attested from memory.",
      "item_has_no_evidence": "This item has no segment backing it.",
      "item_evidence_stale": "The segment for this item changed after the review.",
      "non_objection_needs_confirmation": "It still needs confirming that nobody objected.",
      "meeting_already_purged": "This meeting has already been erased.",
      "segment_out_of_order": "The segments arrived out of order. The recording became inconsistent.",
      "effectuation_target_mismatch": "That destination does not fit this item.",
      "correction_span_outside_segment": "The corrected text falls outside the original segment.",
      "legal_basis_missing": "The legal basis for this meeting does not add up. Please tell the administrator.",
      "not_authorized": "Your role does not allow this action.",
      "reviewer_not_authorized": "Your role does not allow reviewing this meeting.",
      "meeting_restricted": "This meeting is restricted.",
      "erasure_not_authorized": "Only the organizer or an administrator can erase this meeting.",
      "meeting_not_found": "Meeting not found on this account.",
      "item_not_found": "Item not found in this meeting.",
      "tenant_mismatch": "This record belongs to a different company in the system, not yours. Check you're signed into the right account before trying again.",
      "processing_record_missing": "We couldn't find this recording's record in the system. Reopen the meeting from the list; if it keeps happening, tell the administrator the meeting number.",
      "memory_fact_not_found": "That information no longer exists. It was forgotten or never got saved. Refresh the screen before trying again.",
      "segment_not_found": "This piece of the transcript wasn't found. It may already have been replaced. Refresh the screen and try again.",
      "work_order_needs_registered_owner": "This work order needs an owner already registered in the system. Register an owner for the equipment before continuing.",
      "owner_not_in_tenant_registry": "The owner you picked isn't registered in this company. Register that person or choose another registered owner.",
      "processing_record_immutable": "This record is already closed and can't be changed anymore. If something needs correcting, tell whoever handles compliance.",
      "glossary_term_conflict": "This glossary term conflicts with one already saved. Adjust the text or use the existing term.",
      "partial_decision_already_taken": "The decision about this interrupted recording was already made. Open the meeting from the list to see what was decided.",
      "redaction_span_invalid": "The text marked to hide isn't valid at this point in the transcript. Select the text again without going past the original.",
      "navegador_sem_gravacao": "This browser does not record audio. Use Chrome on your phone or computer.",
      "microfone_negado": "Microphone access was denied. Allow access to record.",
      "consentimento_ausente": "Tick the recording notice before starting.",
      "participantes_nao_declarados": "Say how many people are in the room before recording.",
      "desconhecida": "The meeting refused this action for a reason this screen does not know yet ({{code}}). Tell the administrator.",
      "transcript_empty": "The recording did not capture enough speech to generate the minutes. Check whether the device was close to whoever was speaking.",
      "extraction_model_unavailable": "The minutes generator is not configured on this account. The meeting is saved, please tell the administrator.",
      "extraction_output_unparseable": "The minutes generator returned a result that could not be read. The transcript is kept and it can be tried again.",
      "extraction_unexpected_failure": "The minutes could not be generated because of a server failure. The meeting and the transcript are saved, and the minutes can be generated again. If it repeats, tell whoever supports the system.",
      "no_anchored_item_survived": "No item in the minutes held up against what was actually said. The transcript is kept.",
      "anchor_not_found_in_transcript": "The minutes quoted a passage that was not found in the transcript.",
      "extracao_sem_motivo": "The minutes were not generated and the engine did not report a reason. The meeting is saved.",
      "falha_de_rede": "Could not reach the server. Check the device connection and try again.",
      "sessao_expirada": "Your session expired. Sign in again to record the meeting.",
      "sem_permissao": "Your profile cannot open meetings in this account. Ask the administrator to grant access.",
      "muitas_tentativas": "Too many requests in a short time. Wait a minute and try again.",
      "ata_nao_carregou": "The minutes were generated and are saved, but they could not be loaded right now. Close and reopen the conversation, or try again shortly."
    },
    "espera": {
      "parou": "stopped before ending, with {{minutos}} min recorded. Process what was said, or discard?",
      "processar": "Generate the minutes from what was recorded",
      "descartar": "Discard",
      "descartarAviso": "The recording is erased and does not come back.",
      "falhou": "We could not register your choice right now. The recording is still kept; try again shortly."
    }
  },
  "painelConfirmacao": {
    "enviando": "Confirming…",
    "tentarDeNovo": "Try again",
    "semConversa": "Could not send: this conversation is unavailable. Reload the page and try again.",
    "naoEnviou": "The confirmation never left the app. Nothing was saved; check the connection and try again."
  },
  "campoData": {
    "abrirCalendario": "Open calendar",
    "calendario": "Calendar",
    "mesAnterior": "Previous month",
    "mesSeguinte": "Next month",
    "diasDaSemana": "S,M,T,W,T,F,S",
    "placeholder": "dd/mm/yyyy"
  },
  "campoSelecao": {
    "selecionar": "Select"
  },
  "manualIngest": {
    "stage": {
      "queued": "Waiting in line to read the manual",
      "reading": "Reading the manual: pages {{done}} of {{total}}",
      "readingNoTotal": "Reading the manual",
      "ocr": "Recognizing text on scanned pages (OCR): {{done}} of {{total}}",
      "indexing": "Organizing the manual content",
      "structuring": "Building the maintenance plan",
      "ready": "Manual read",
      "failed_retryable": "Reading stopped and can resume where it left off",
      "failed": "I could not finish reading the manual",
      "cancelled": "Reading cancelled",
      "paused_decision": "I reached this month's safety limit."
    },
    "detail": {
      "ocr_one": "{{n}} page with OCR",
      "ocr_other": "{{n}} pages with OCR",
      "illegible_one": "{{n}} illegible page",
      "illegible_other": "{{n}} illegible pages"
    },
    "progressAria": "Pages read: {{done}} of {{total}}",
    "cancel": "Cancel reading",
    "retry": "Try again",
    "acknowledge": "Got it",
    "actionFailed": "I could not do that right now. I refreshed the reading status.",
    "continue": "Continue",
    "stop": "Stop",
    "delete": {
      "action": "Delete manual",
      "aria": "Delete the manual {{name}}",
      "confirm": "Delete the manual {{name}}? The text read and the file will be erased. The record of the deletion is kept.",
      "failed": "I could not delete the manual. Nothing was deleted.",
      "reasonLabel": "Reason (optional)",
      "confirmAction": "Delete",
      "back": "Back",
      "done": "Manual deleted on {{when}}",
      "doneBy": "Manual deleted on {{when}} by {{who}}"
    },
    "sources": {
      "title": "I will combine these sources",
      "remove": "Remove",
      "removeAria": "Remove {{name}} from the sources"
    },
    "run": {
      "title_one": "Reading {{count}} file",
      "title_other": "Reading {{count}} files",
      "titleCancelled": "Reading cancelled",
      "wave": "Group {{index}} of {{total}}",
      "aggregate": "{{done}} of {{total}} pages",
      "filePages": "{{done}} of {{total}} pages",
      "queueNext": "Queued: it is the next reading",
      "queueAhead_one": "Queued: {{count}} reading ahead of you",
      "queueAhead_other": "Queued: {{count}} readings ahead of you",
      "cancelFile": "Cancel",
      "cancelFileAria": "Cancel reading {{name}}",
      "retryFileAria": "Try reading {{name}} again",
      "cancelAll": "Cancel all",
      "buildWithout": "Build without it",
      "asking": "Some file could not be read. Try again or build the plan without it?",
      "paused": "I reached this month's safety limit.",
      "fileState": {
        "queued": "Queued",
        "reading": "Reading",
        "ocr": "Recognizing text (OCR)",
        "indexing": "Organizing",
        "structuring": "Building the plan",
        "ready": "Read",
        "failed_retryable": "Stopped, can resume",
        "failed": "Could not read it",
        "cancelled": "Cancelled",
        "paused_decision": "Paused"
      }
    }
  },
  "research": {
    "notice": {
      "running": "Looking up the {{label}} plan · {{elapsed}} of up to {{ceiling}}",
      "ready": "The {{label}} plan arrived. Tap to see it.",
      "failed": "I couldn't get the {{label}} plan. The provisional plan still applies.",
      "ceilingMinutes": "{{count}}min",
      "openAria": "Open the conversation where the search started"
    },
    "provisionalBadge": "Provisional, looking up the manufacturer manual",
    "arrived": "The manufacturer manual arrived, I updated the plan.",
    "compare": {
      "title": "The manufacturer manual arrived and your plan was already saved",
      "added_one": "{{count}} new task in the manual",
      "added_other": "{{count}} new tasks in the manual",
      "changed_one": "{{count}} task with a different interval",
      "changed_other": "{{count}} tasks with a different interval",
      "same_one": "{{count}} identical task",
      "same_other": "{{count}} identical tasks",
      "apply": "Apply manual",
      "keep": "Keep mine"
    }
  },
  "ferramentas": {
    "nome": {
      "create_equipment": "Registered the equipment",
      "create_location": "Registered the location",
      "create_maint_plan": "Built the maintenance plan",
      "create_task_list": "Built the task list",
      "create_wo_operation": "Added an operation to the order",
      "create_work_order": "Opened a work order",
      "get_equipment": "Opened the equipment record",
      "get_maint_plan": "Opened the maintenance plan",
      "get_plant_list": "Listed the plants",
      "get_work_order": "Opened the work order",
      "list_materials": "Listed the materials",
      "query_maintenance_metrics": "Looked up the maintenance indicators",
      "search_equipment": "Searched equipment",
      "search_form": "Searched forms",
      "search_maint_plan": "Searched maintenance plans",
      "search_manufacturer": "Searched manufacturers",
      "search_material": "Searched materials",
      "search_notification": "Searched notifications",
      "search_team": "Searched teams"
    },
    "parametro": {
      "dims": "Breakdown",
      "entity": "Record",
      "filters": "Filters",
      "from": "From",
      "limit": "Limit",
      "metrics": "Indicators",
      "period": "Period",
      "query": "Search",
      "status": "Status",
      "to": "To"
    },
    "valor": {
      "area": "Area",
      "availability": "Availability",
      "backlog_weeks": "Backlog (weeks)",
      "compliance": "Plan compliance",
      "corrective": "Corrective",
      "equipment": "Equipment",
      "location": "Location",
      "month": "Month",
      "mtbf": "MTBF",
      "mttr": "MTTR",
      "predictive": "Predictive",
      "preventive": "Preventive",
      "quarter": "Quarter",
      "team": "Team",
      "week": "Week"
    }
  },
  "schedule": {
    "review": {
      "historyUnavailable": "Saved versions could not be loaded.",
      "versions": "Saved versions",
      "exportExcel": "Export version Excel",
      "exportPdf": "Export version PDF",
      "specialtyLoad": "Load and capacity by specialty",
      "specialty": "Specialty",
      "week": "Week",
      "before": "Load before (h)",
      "after": "Load after (h)",
      "capacity": "Capacity (h)",
      "unknownCapacity": "Not provided",
      "unknownSpecialty": "Specialty not provided"
    },
    "unlinkedArea": "No linked area",
    "areaUnavailable": "Area unavailable",
    "areaMetadataError": "Areas could not be loaded. The schedule remains available.",
    "areaContext": "Area: {{names}}",
    "readOnly": "Read-only: only an administrator or manager can move or edit the schedule.",
    "warning": {
      "totalShutdown": "Total shutdown week: the task was saved anyway.",
      "totalShutdownWeek": "Week {{week}} is a total shutdown: the task was saved anyway."
    },
    "level": {
      "title": "Level workload",
      "description": "Review the proposal and its impact before applying. Generating a proposal changes no dates.",
      "impact": "Weekly maximum: {{before}} → {{after}} h. Deviation: {{beforeDeviation}} → {{afterDeviation}}.",
      "move": "{{plan}} · Week {{from}} → {{to}} · {{hours}} h",
      "empty": "No recommended moves.",
      "propose": "Generate proposal",
      "apply": "Apply proposal"
    },
    "reloadRetry": "The version was saved, but the board did not load. Use Save to retry loading.",
    "undoUnavailable": "Undo unavailable: the server did not provide a valid restore record.",
    "undoBlockDone": "Block on weeks {{from}} to {{to}} undone.",
    "undoExpired": "Could not undo: the schedule changed after the move or the undo record expired. The grid was reloaded.",
    "title": "Annual {{weeks}}-Week Schedule",
    "aiBadge": "{{count}} AI-inferred",
    "aiBadgeShowOnly": "show only these",
    "aiBadgeShowAll": "show all",
    "annualSummary": "{{equipment}} equipment · {{plans}} plans · {{orders}} annual work orders · {{hours}}h",
    "annualSummaryWithoutHours": "{{equipment}} equipment · {{plans}} plans · {{orders}} annual work orders · Hours not estimated",
    "titleWeek": "Schedule for Week {{week}}/{{year}}",
    "weekSummary": "{{equipment}} equipment · {{plans}} plans · {{orders}} work orders this week · {{hours}}h",
    "weekSummaryWithoutHours": "{{equipment}} equipment · {{plans}} plans · {{orders}} work orders this week · Hours not estimated",
    "summary": "{{orders}} WOs this year · {{hours}}h",
    "currentWeek": "this week: {{orders}} orders · {{hours}}h",
    "equipmentCount": "{{count}} equipment",
    "blocked": "Blocked",
    "shutdown": "Shutdown",
    "today": "Today",
    "crit": {
      "label": "Criticality",
      "a": "A",
      "b": "B",
      "c": "C"
    },
    "picker": {
      "chooseAtLeastOne": "Choose at least 1",
      "simulateSelected": "Simulate {{count}} equipment",
      "simulateStart": "Simulate",
      "simulateRequest": "Simulate 52 weeks",
      "simulatePlant": "Simulate whole plant",
      "loading": "Loading the 52-week schedule…",
      "loadError": "The schedule could not be loaded. Check your connection and try again using the controls below.",
      "noScenario": "There is no 52-week schedule for this selection yet. Define the schedule for one piece of equipment at a time.",
      "forbidden": "Your role does not allow opening the 52-week schedule.",
      "refused": "The engine refused to open this schedule. Check the equipment plan and try again.",
      "defineSchedule": "Define schedule for {{tag}}",
      "plant": "Plant",
      "choosePlant": "Select a plant",
      "title": "Choose equipment",
      "hint": "Choose one or more pieces of equipment to see the yearly schedule.",
      "criticalOnly": "Only critical A",
      "wholePlant": "Whole plant",
      "viewSelected": "View {{count}} equipment",
      "empty": "No equipment registered in this plant."
    },
    "commands": {
      "cronograma": {
        "label": "Year schedule",
        "description": "52-week year"
      }
    },
    "actions": {
      "versions": "Saved versions",
      "expand": "Open schedule",
      "save": "Save",
      "compare": "Baseline",
      "compareDisabled": "Available in a future release",
      "excel": "Excel",
      "pdf": "PDF A3",
      "exportExcel": "Export Excel (.xlsx) formatted for PCM",
      "exportPdf": "Export PDF, industrial A3 format",
      "saveVersion": "Save Simulation",
      "saveChanges": "Save Changes",
      "saveDisabled": "Available in a future release",
      "exportError": "Could not export the schedule.",
      "exportDisabled": "Nothing to export: the active filter leaves this card's grid empty."
    },
    "filters": {
      "all": "All",
      "criticalEquipment": "Critical Grade A",
      "taskCriticalityA": "Grade A tasks",
      "search": "Filter equipment...",
      "area": "{{names}} · {{count}}"
    },
    "period": {
      "label": "Schedule period",
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "year": "Year"
    },
    "status": {
      "dragDate": "Destination: week {{to}} (from {{date}})",
      "dragAnnounce": "Destination: week {{to}}, from {{date}}.",
      "hint": "Click or drag an occurrence. Select weeks on the ruler to block them.",
      "capacity": "Team capacity: {{hours}}h",
      "readOnly": "Read only",
      "scenario": "Scenario: {{name}} v{{version}}",
      "comparing": "Comparing with: {{label}}",
      "move": "Move: {{label}} → W{{to}}",
      "deviation": "Deviation vs Baseline: {{weeks}} Weeks ({{days}}d)",
      "loading": "Loading schedule",
      "loadError": "Could not load the schedule: {{message}}",
      "undo": "Undo",
      "teamLoad": "Team load: {{hours}}h/{{capacity}}h",
      "capacityUnknown": "Capacity not provided",
      "capacityOver": "Above capacity",
      "capacityIdeal": "Ideal capacity"
    },
    "quarter": {
      "shutdown": "Plant Shutdown",
      "range": "Wk {{from}} - {{to}} · {{months}}",
      "assetHeader": "Asset & Criticality",
      "months": {
        "1": "Jan - Mar",
        "2": "Apr - Jun",
        "3": "Jul - Sep",
        "4": "Oct - Dec"
      }
    },
    "isoYearColumns": "Weeks of {{year}}",
    "gridTop": {
      "yearWeeks": "{{year}} · {{count}} weeks",
      "iso53": "ISO 53",
      "blockWeeks": "Block weeks",
      "breadcrumb": "Equipment › Plans › Tasks",
      "rulerLabel": "{{year}} · Week",
      "rulerLabelDays": "Day",
      "periodRange": "{{from}} to {{to}}",
      "todayWeek": "Today · Week {{week}}",
      "weekN": "Week {{week}}"
    },
    "task": {
      "summary": "{{duration}} · {{technician}}",
      "edit": "Edit task",
      "addIntervention": "+ Intervention"
    },
      "year": {
        "label": "Schedule year",
        "single": "Only {{year}} has a simulated scenario.",
        "loadError": "Could not open that year's scenario."
      },
    "tabs": {
      "label": "Schedule sections",
      "schedule": "Schedule",
      "plans": "Plans",
      "cost": "Budget and costs",
      "capacity": "Team capacity",
      "exclusions": "Warnings and exclusions",
      "versions": "Versions",
      "orders": "Work orders",
      "audit": "Audit"
    },
    "panels": {
      "plans": {
        "title": "Plans and tasks",
        "empty": "No plan with tasks in this filter.",
        "col": {
          "equipment": "Equipment",
          "plan": "Plan",
          "task": "Task",
          "criticality": "Criticality",
          "duration": "Duration",
          "source": "Source",
          "rationale": "Rationale"
        },
        "inferred": "Inferred by AI",
        "reviewed": "Reviewed"
      },
      "orders": {
        "title": "Work orders",
        "empty": "No order in this filter.",
        "simulated": "Simulated",
        "truncated": "Showing {{shown}} of {{total}} orders, by date. Use Excel for the full list.",
        "refresh": "Refresh schedule",
        "col": {
          "order": "Order",
          "equipment": "Equipment",
          "plan": "Plan",
          "date": "Date",
          "week": "Week",
          "status": "Status",
          "hours": "Hours",
          "technician": "Technician",
          "actions": "Actions"
        },
        "status": {
          "done": "Done",
          "open": "Open",
          "planned": "Planned",
          "overdue": "Overdue"
        },
        "adHoc": "Ad hoc",
        "action": {"edit": "Edit order", "technician": "Change technician", "week": "Change week", "cancel": "Cancel order"},
        "field": {"description": "Order description", "reason": "Cancellation reason", "technician": "Technician", "year": "Year", "week": "Week"},
        "noTechnician": "No technician",
        "save": "Save",
        "close": "Close"
      },
      "exclusions": {
        "title": "Warnings and exclusions",
        "refresh": "Refresh warnings",
        "empty": "No warnings: every plan in this filter is on the grid.",
        "week53": "2026 has 53 ISO weeks: showing 53 columns is not an error.",
        "inactive": "Inactive plans (off the grid)",
        "notSchedulable": "Plans without a fixed date (per shift or per condition)",
        "blocks": "Date blocks and shutdowns",
        "omitted": "{{count}} decommissioned equipment omitted from the grid.",
        "inactiveItem": "{{tag}} · {{plan}} is inactive and is not on the grid.",
        "notSchedulableItem": "{{tag}} · {{plan}} cannot be scheduled by date: {{band}}.",
        "blockItem": "{{kind}} · weeks {{from}} to {{to}} · {{reason}}",
        "blockKind": {
          "date_block": "Date block",
          "total_shutdown": "Plant shutdown"
        }
      },
      "capacity": {
        "title": "Team capacity",
        "empty": "No week with planned hours in this scenario.",
        "summary": "{{hours}}h planned · {{over}} week(s) over capacity.",
        "summaryNoCapacity": "{{hours}}h planned · team capacity not registered.",
        "view": {
          "label": "Capacity view",
          "week": "Week",
          "month": "Month",
          "monthTable": "Capacity by month"
        },
        "specialty": {
          "title": "Hours by specialty",
          "none": "No specialty",
          "unnamed": "Unnamed specialty",
          "col": {
            "name": "Specialty",
            "hours": "Planned",
            "capacity": "Capacity per week",
            "over": "Weeks over"
          }
        },
        "usage": {
          "title": "Average usage of meter-based plans",
          "hint": "Plans by hours, km or cycles only enter the schedule once the equipment's average daily usage is entered.",
          "save": "Set usage",
          "saved": "Average usage saved.",
          "saveError": "Could not save the average usage.",
          "loadError": "Could not read the plans' average usage.",
          "invalid": "Enter a number greater than zero.",
          "missing": "Not entered",
          "col": {
            "equipment": "Equipment",
            "plan": "Plan",
            "cycle": "Cycle",
            "usage": "Average usage per day",
            "action": "Action"
          },
          "unit": {
            "HOURS": "By operating hours",
            "KILOMETERS": "By kilometers",
            "CYCLES": "By cycles",
            "UNITS": "By units"
          }
        },
        "col": {
          "month": "Month",
          "week": "Week",
          "hours": "Planned",
          "capacity": "Capacity",
          "load": "Load",
          "status": "Status"
        },
        "alert": {
          "ok": "Within capacity",
          "over": "Over capacity",
          "idle": "Idle",
          "unknown": "Capacity not registered"
        }
      },
      "cost": {
        "title": "Budget and costs",
        "empty": "No forecast cost in this scenario.",
        "summary": "Forecast material: {{material}} · labor: {{hours}}h.",
        "noBudget": "Annual budget not provided: the schedule card carries no budget, only the weekly forecast.",
        "import": {
          "title": "Import budget",
          "hint": "A .xlsx, .xls or .csv sheet with plant, type (week or month), year, period and the planned cost and/or hours columns.",
          "file": "Budget spreadsheet",
          "button": "Import budget",
          "busy": "Importing…",
          "done": "{{count}} budget period(s) imported.",
          "error": "Could not import the spreadsheet. Try again.",
          "summary": "{{count}} period(s) saved, {{replaced}} replaced a previous value.",
          "rejectedRow": "Row {{row}} refused: {{reason}}",
          "plantNotFound": "Plant not registered: {{plant}} (register the plant first).",
          "rejectedEntry": "{{plant}}, period {{period}}: {{reason}}"
        },
        "budget": {
          "title": "Set planned budget",
          "plant": "Plant",
          "periodType": "Period",
          "year": "Year",
          "month": "Month",
          "week": "Week",
          "save": "Set budget",
          "saved": "Budget for {{period}} saved.",
          "saveError": "Could not save the budget. Try again.",
          "loadError": "Could not read the saved budget.",
          "invalid": "Use numbers only (e.g. 1500 or 1,500.50) in the marked fields.",
          "col": {
            "period": "Period",
            "budgetCost": "Cost budget",
            "budgetHours": "Hours budget",
            "plannedHours": "Planned hours",
            "plannedMaterial": "Planned material"
          },
          "months": {
            "1": "January",
            "2": "February",
            "3": "March",
            "4": "April",
            "5": "May",
            "6": "June",
            "7": "July",
            "8": "August",
            "9": "September",
            "10": "October",
            "11": "November",
            "12": "December"
          }
        },
        "col": {
          "week": "Week",
          "hours": "Labor",
          "material": "Material"
        }
      },
      "loading": "Loading…",
      "versions": {
        "title": "Saved versions",
        "empty": "No saved version yet. Use \"Save Changes\" to keep one.",
        "current": "Shown",
        "col": {
          "version": "Version",
          "name": "Name",
          "date": "Saved on",
          "current": "Status"
        }
      },
      "audit": {
        "title": "Scenario audit",
        "empty": "No audit record for this scenario in the tenant's latest 100 events.",
        "forbidden": "Audit is only available to administrators.",
        "failed": "Could not load the audit right now.",
        "interventionAdded": "Intervention opened: {{description}}",
        "action": {
          "create": "Scenario created",
          "update": "Scenario updated",
          "delete": "Scenario deleted",
          "LTP_SCENARIO_VERSION_SAVED": "Version saved",
          "LTP_INFERENCE_ACKNOWLEDGED": "AI values acknowledged",
          "unknown": "Other action"
        },
        "col": {
          "at": "When",
          "action": "Action",
          "actor": "Who"
        }
      }
    },
    "plan": {
      "tolerance": "Tolerance: −{{early}}% / +{{late}}%",
      "editCycle": "Cycle and plan details",
      "lineSymmetric": "{{cycle}} · {{hours}}h · ±{{tolerance}}%",
      "lineAsymmetric": "{{cycle}} · {{hours}}h · −{{early}}% / +{{late}}%",
      "summary": "{{cycle}} · {{hours}}h",
      "activate": "Activate"
    },
    "procedure": {
      "title": "Procedure",
      "empty": "No procedure tasks available for this plan"
    },
    "planDetails": {
      "title": "Plan details",
      "description": "Brings together this plan's procedure and its occurrences in the schedule shown.",
      "selectedOne": "Selected occurrence",
      "selectedMany": "Selected occurrences this week",
      "selectedBadge": "Selected",
      "occurrences": "Plan occurrences ({{count}})",
      "others": "Other occurrences ({{count}})",
      "onlyOccurrence": "This is the plan's only occurrence in the schedule shown.",
      "noOccurrences": "No occurrences of this plan in the schedule shown.",
      "weekOfYear": "Week {{week}} · {{year}}",
      "sameWeek": "{{index}} of {{total}} this week",
      "linkedOrder": "Linked work order",
      "listLabel": "Plan occurrences list"
    },
    "lane": {
      "choosePlan": "Choose a plan for this equipment",
      "shortTechnician": "Technician",
      "shortLevel": "Level Load",
      "collapse": "Collapse",
      "expand": "Expand",
      "summary": "{{plans}} plans · {{orders}} WOs",
      "addIntervention": "+ Intervention",
      "empty": "No equipment matches this filter."
    },
    "legend": {
      "aiInferred": "AI · dashed outline indicates inferred data",
      "occurrenceMoved": "Moved",
      "weekToday": "Current week",
      "weekBlocked": "Date block",
      "weekShutdown": "Collective shutdown"
    },
    "occurrence": {
      "week": "W{{week}}",
      "weekBadge": "W{{week}}",
      "tooltip": "W{{week}}/{{year}} · {{date}} · {{status}}",
      "movedFrom": "moved from W{{week}}",
      "group_one": "{{count}} occurrence · W{{week}} · {{states}}",
      "group_other": "{{count}} occurrences · W{{week}} · {{states}}",
      "status": {
        "done": "Completed",
        "open": "Open",
        "planned": "Planned",
        "overdue": "Overdue"
      }
    },
    "footer": {
      "dragHint": "Drag active · ← → Enter Esc",
      "readOnly": "Read only",
      "dropHint": "Enter confirms · Esc discards",
      "willWriteOrder": "Preview: plan call {{label}} → W{{week}} · WO {{code}} will be rescheduled",
      "destination": "{{label}} → W{{week}}",
      "selection": "Selection:",
      "technician": "Assigned technician:",
      "impact": "Line Impact:",
      "noImpact": "Not available",
      "discard": "Discard",
      "confirm": "Confirm Change",
      "writeDisabled": "Available in a future release",
      "willWrite": "Preview: plan call {{label}} → W{{week}} · will be rescheduled",
      "noChange": "No change: {{label}} remains in week {{week}}.",
      "scopeOnly": "Only this occurrence",
      "scopeFollowing": "This and following",
      "followingNote": "The following occurrences of this plan also move, by the same shift.",
      "reasonLabel": "Reason",
      "reasonRequiredHint": "Give a reason (critical task outside tolerance)",
      "operating": "Continuous",
      "partialStop": "Partial",
      "fullStop": "Full",
      "editTechnician": "Edit responsible technician"
    },
    "dragOutcome": {
      "moved": "{{label}} rescheduled to week {{week}} (from {{date}}).",
      "refused": "Not saved:"
    },
    "dragError": {
      "invalidWeek": "Target week is invalid or outside the schedule horizon. Pick another week.",
      "conflict": "This occurrence changed since the screen was loaded. Refresh the schedule and try again."
    },
    "inlineEdit": {
      "duration": "Time (min)",
      "technician": "Technician",
      "team": "Team",
      "criticality": "Criticality",
      "rationale": "Reason",
      "rationalePlaceholder": "Why this criticality?",
      "save": "Save",
      "cancel": "Cancel",
      "none": "-",
      "inferredBadge": "AI-inferred"
    },
    "dateBlock": {
      "title": "Weeks {{from}} to {{to}}",
      "dateBlockKind": "Date block",
      "totalShutdownKind": "Full shutdown",
      "confirm": "Confirm block",
      "reasonPlaceholder": "Why is this window blocked?",
      "multiplePlants": "Schedule shows more than one plant, filter by a single plant to block dates.",
      "noPlant": "No equipment with a plant in this schedule."
    },
    "ack": {
      "title": "AI-filled values",
      "body": "This plan has {{count}} values filled in by AI ({{fields}}).",
      "warning": "AI can be wrong. Review the items marked with the inferred star before using this schedule to buy material or book a crew.",
      "review": "Review the {{count}} items",
      "confirm": "I'm aware and want to save",
      "field": {
        "duration": "Duration",
        "usage_rate": "Usage rate",
        "cycle_start": "Cycle start",
        "team": "Team",
        "task_criticality": "Task criticality"
      }
    },
    "compare": {
      "orders": "Δ WOs: {{delta}}",
      "hours": "Δ Hours: {{delta}}h",
      "cost": "Δ Cost: {{delta}}"
    },
    "intervention": {
      "visibilityUnverified": "Visibility in the grid has not been verified. Check the current window and filters.",
      "createdWithoutCode": "Intervention created. The work-order number is unavailable.",
      "createdWithCode": "Intervention created: {{code}}.",
      "reloadRetry": "The intervention was created, but the schedule did not load. Retry the refresh; another intervention will not be created.",
      "retry": "Refresh schedule",
      "description": "Description",
      "descriptionPlaceholder": "What needs to be done?",
      "confirm": "Open intervention",
      "review": "This will open a corrective work order this week: «{{description}}». Confirm?",
      "reviewConfirm": "Confirm opening",
      "back": "Back"
    }
  },
  "platform": {
    "novaEmpresa": "New company",
    "criarEmpresa": "Create and invite",
    "criandoEmpresa": "Creating…",
    "ajudaEmailDoAdmin": "This person gets the invitation by e-mail and joins as the company admin. They invite the rest of the team.",
    "liberacoes": {
      "titulo": "Releases",
      "subtitulo": "New features released in this environment. A key applies to every company.",
      "ligada": "On",
      "desligada": "Off",
      "ligadaDev": "On (development)",
      "travadaDev": "In development the key is always on and cannot be turned off.",
      "ambiente": "Environment",
      "dono": "Owner",
      "venceEm": "Expires on",
      "oQueMuda": "What changes on screen",
      "carregando": "Loading releases…",
      "vazio": "No release keys.",
      "erro": "Could not load or change the releases. Try again.",
      "ligar": "Turn on {{nome}}",
      "desligar": "Turn off {{nome}}"
    },
    "aba": "Companies",
    "titulo": "Platform companies",
    "subtitulo": "Every registered company and the people in each one.",
    "buscarEmpresa": "Search company",
    "buscarPessoa": "Search person",
    "escolhaUmaEmpresa": "Pick a company from the list.",
    "plano": "Plan",
    "pessoasAtivas": "Active people",
    "pessoasTotal": "Registered people",
    "pessoaAtiva": "Active",
    "pessoaInativa": "Inactive",
    "suspenderEmpresa": "Suspend company",
    "reativarEmpresa": "Reactivate company",
    "novaPessoa": "New person",
    "editarPessoa": "Edit person",
    "editar": "Edit",
    "desativar": "Deactivate",
    "reativar": "Reactivate",
    "cancelar": "Cancel",
    "salvar": "Save",
    "salvando": "Saving...",
    "fechar": "Close",
    "emailNaoMuda": "The e-mail is how this person signs in. It cannot be changed here.",
    "convitesPendentes": "{{count}} invitation(s) created and not yet accepted.",
    "situacao": {
      "active": "Active",
      "suspended": "Suspended"
    },
    "campo": {
      "email": "E-mail",
      "nome": "Name",
      "papel": "Role",
      "nomeDaEmpresa": "Company name",
      "emailDoAdmin": "Company admin e-mail"
    },
    "validacao": {
      "email": "Enter a valid e-mail.",
      "nome": "Enter the name.",
      "nomeDaEmpresa": "Enter the company name."
    },
    "papel": {
      "admin": "Administrator",
      "manager": "Manager",
      "technician": "Technician",
      "viewer": "Viewer"
    },
    "coluna": {
      "nome": "Name",
      "email": "E-mail",
      "papel": "Role",
      "situacao": "Status",
      "acoes": "Actions"
    },
    "confirmarSuspender": {
      "titulo": "Suspend this company?",
      "mensagem": "People at {{nome}} lose access while the company is suspended. Nothing is deleted, and you can reactivate at any time."
    },
    "confirmarDesativar": {
      "titulo": "Deactivate this person?",
      "mensagem": "{{nome}} loses access and stays on the list, marked inactive. You can reactivate at any time."
    },
    "erro": {
      "USER_EXISTS": "A person with this e-mail already exists in this company.",
      "USER_EXISTS_OTHER_TENANT": "This e-mail already belongs to another company.",
      "CANNOT_DEACTIVATE_SELF": "You cannot deactivate yourself.",
      "INVITE_FAILED": "The invitation could not be sent. Nothing was created; try again.",
      "ROLE_NOT_PROVISIONED": "This company does not have that role configured yet.",
      "TENANT_NOT_FOUND": "Company not found.",
      "USER_NOT_FOUND": "Person not found in this company.",
      "FORBIDDEN_PLATFORM_ADMIN": "You do not have access to this area.",
      "NETWORK": "No answer from the server. Check the connection and try again.",
      "DESCONHECIDO": "Could not complete. Try again; if it repeats, contact support.",
      "INVITE_ALREADY_PENDING": "This person was already invited and has not accepted yet.",
      "TENANT_SLUG_TAKEN": "A company with this name already exists.",
      "CATALOG_NOT_SEEDED": "This database does not have the plan or the admin role set up yet."
    }
  },
  "planComparison": {
    "title": "Plan comparison",
    "equipment": "Equipment: {{manufacturer}} {{model}}",
    "summaryLabel": "Comparison summary",
    "client": "Your plan",
    "reference": "Reference",
    "absent": "Not listed",
    "every": "Every {{value}} {{unit}}",
    "noInterval": "No interval given",
    "row": "Spreadsheet row {{number}}: {{text}}",
    "source": "Source: {{host}}",
    "unverified": "Source not verified",
    "notCompared": "Different units: not compared numerically.",
    "assumir": "Adopt as official plan",
    "useEquipment": "Use {{manufacturer}} {{model}}",
    "status": {
      "igual": "Same",
      "intervalo_diferente": "Different interval",
      "falta_no_cliente": "Missing from your plan",
      "so_no_cliente": "Only in your plan",
      "nao_comparavel": "Not comparable"
    },
    "adopt": {
      "intervalo_diferente": "Use the reference interval",
      "falta_no_cliente": "Add to my plan"
    },
    "unit": {
      "HOURS_one": "hour",
      "HOURS_other": "hours",
      "DAYS_one": "day",
      "DAYS_other": "days",
      "WEEKS_one": "week",
      "WEEKS_other": "weeks",
      "MONTHS_one": "month",
      "MONTHS_other": "months",
      "YEARS_one": "year",
      "YEARS_other": "years",
      "CYCLES_one": "cycle",
      "CYCLES_other": "cycles"
    },
    "band": {
      "por_turno": "Per shift",
      "diaria": "Daily",
      "semanal": "Weekly",
      "mensal": "Monthly",
      "trimestral": "Quarterly",
      "semestral": "Semiannual",
      "anual": "Annual",
      "por_hora_operacao": "Per operating hour",
      "por_condicao": "Condition-based"
    }
  },
  "guardian": {
    "commands": {
      "label": "Create agent",
      "sub": {
        "novo": "Describe a new agent",
        "listar": "See your agents in the panel",
        "rodar": "Prepare a plan now",
        "pausar": "Stop the next runs",
        "editar": "Adjust the agent rule",
        "retomar": "Resume a paused agent"
      },
      "loadAgents": "Load your agents"
    },
    "create": "Create agent",
    "missing": "Not defined yet",
    "inferred": "Inference: view reason",
    "specificApproval": "Your approval covers only this plan and these effects.",
    "expires": "Approval available until {{date}}",
    "results": "{{count}} results",
    "empty": "No agents in this conversation.",
    "recommended": "Recommended",
    "readOnly": "Read only",
    "sendAnswer": "Send answer",
    "deliveryFailed": "This action could not be sent. Check the current state in the conversation before continuing.",
    "fields": {
      "where": "Where",
      "object": "Object",
      "action": "Action",
      "when": "When",
      "exceptions": "Exceptions"
    },
    "state": {
      "DRAFT": "Draft",
      "ENTRY_REVIEW": "Reviewing definition",
      "CLARIFYING": "Definition needed",
      "CONFIRMING": "Confirmation pending",
      "BLIND_CHECK": "Checking meaning",
      "CAPABILITY_CHECK": "Checking capabilities",
      "DRY_RUNNING": "Simulation running",
      "EVIDENCE_BLOCKED": "Insufficient evidence",
      "EVIDENCE_READY_AWAITING_CHOICE": "Almost ready to activate",
      "READY": "Ready to activate",
      "ACTIVE": "Active · proposes and requests approval",
      "ACTIVE_act_within_limits": "Active · acts and notifies you",
      "PLAN_REVIEW": "Plan under review",
      "AWAITING_APPROVAL": "Awaiting approval",
      "EXECUTING": "Executing approved plan",
      "RECONCILING": "Verifying result",
      "RECEIPT": "Verified result",
      "PAUSED": "Paused",
      "BLOCKED": "Blocked"
    },
    "card": {
      "agentPolicy": "Agent policy",
      "agentApproval": "Approve specific plan",
      "agentReceipt": "Run result",
      "agentExplanation": "Explanation and audit",
      "agentPanel": "Maintenance agents",
      "agentRun": "Agent run",
      "agentBreaker": "Agent breaker",
      "agentTemplates": "Ready-made templates"
    },
    "approval": {
      "reviewing": "Under review",
      "blocked": "Blocked",
      "awaiting_approval": "Awaiting approval",
      "approved": "Approved",
      "rejected": "Rejected",
      "expired": "Expired"
    },
    "outcome": {
      "succeeded": "Verified",
      "partial": "Partial",
      "failed": "Failed",
      "unverified": "Unverified result",
      "none": "No execution",
      "awaiting_approval": "Awaiting approval"
    },
    "dryRun": {
      "not_started": "Not started",
      "running": "Running",
      "sufficient": "Sufficient evidence",
      "insufficient": "Insufficient evidence",
      "failed": "Failed"
    },
    "method": {
      "historical_replay": "Real history replay",
      "synthetic_history_replay": "Synthetic history replay",
      "current_snapshot": "Current state preview"
    },
    "review": {
      "approve": "Approved",
      "reject": "Rejected",
      "unavailable": "Unavailable"
    },
    "confirmation": {
      "pending": "Pending",
      "confirmed": "Confirmed"
    },
    "mode": {
      "manual": "Manual",
      "scheduled": "Scheduled"
    },
    "nextRun": "Next run: {{date}}",
    "lastOutcome": "Last result",
    "effectPending": "This execution has pending issues. Check the reasons and audit.",
    "samples": "{{count}} records examined",
    "d6": {
      "pending": "Understanding under review",
      "blocked": "Understanding blocked",
      "green": "Understanding verified"
    },
    "boolean": {
      "true": "Yes",
      "false": "No"
    },
    "noValue": "No value",
    "recordedDecision": "Admissibility decision recorded",
    "admissibility": {
      "pending": "Admissibility pending",
      "accepted": "Admissibility accepted",
      "rejected": "Admissibility rejected"
    },
    "rejectionReason": "Reason for rejection",
    "confirmRejection": "Reject this plan",
    "checkState": "Check current agent state",
    "run": {
      "meta": "version {{version}} · {{trigger}} · {{date}}",
      "receipt": "Receipt {{label}}",
      "created": "new",
      "showAll": "See all {{count}} actions",
      "step": {
        "pending": "pending",
        "pending_verification": "awaiting check",
        "uncertain": "uncertain result",
        "blocked": "blocked",
        "failed": "failed"
      },
      "status": {
        "running": "Running",
        "completed": "Completed",
        "nothing_to_do": "Nothing to do",
        "awaiting_approval": "Awaiting approval",
        "rejected_by_guardian": "Rejected by Guardian",
        "rejected_by_human": "Declined by you",
        "breaker_tripped": "Stopped by the breaker",
        "partial": "Partial",
        "receipt_failed": "Receipt not verified",
        "uncertain": "Uncertain result",
        "failed": "Failed"
      },
      "field": {
        "type": "Type",
        "status": "Status",
        "equipmentTag": "Equipment",
        "equipmentId": "Equipment",
        "description": "Description",
        "priority": "Priority",
        "notificationId": "Maintenance notification",
        "planId": "Plan",
        "planTaskId": "Plan task",
        "plannedStart": "Planned start",
        "plannedEnd": "Planned end",
        "breakdown": "Equipment breakdown",
        "mainTeamId": "Responsible team",
        "criticality": "Criticality",
        "operationId": "Linked operation",
        "technicianId": "Assigned technician",
        "participation": "Technician participation",
        "taskListType": "Task list type",
        "taskListGroup": "Task list group",
        "taskListGroupCounter": "Task list variant"
      }
    },
    "breaker": {
      "per_run": "Per-run limit",
      "per_day": "Daily limit",
      "per_tenant_day": "Company daily limit",
      "repeated_pattern": "Repeated pattern",
      "out_of_scope": "Out of scope"
    },
    "rewrite": "Rewrite the rule",
    "defineMissing": "Define what is missing",
    "activate": "Activate",
    "question": {
      "confirm": "Confirm",
      "writeOther": "Write another answer"
    },
    "panel": {
      "title": "Your agents",
      "count_one": "{{count}} active of {{total}}",
      "count_other": "{{count}} active of {{total}}",
      "close": "Close agents panel",
      "open": "Open agents panel",
      "load": "Load agents",
      "loading": "Loading your agents…",
      "empty": "No agents yet. Describe in the chat what an agent should do.",
      "more": "See more agents",
      "pointer_one": "{{count}} agent in the panel on the right",
      "pointer_other": "{{count}} agents in the panel on the right",
      "version": "version {{version}}",
      "approvedBy": "approved by {{name}} on {{date}}",
      "runs": "Runs",
      "next": "Next",
      "timezoneNamed": "{{city}} time",
      "lastRun": "Last run",
      "resume": "Resume", "never": "never"
    },
    "seal": {
      "explicit": "In the text",
      "assumed": "Assumed",
      "confirmed": "Confirmed",
      "missing": "Not defined"
    },
    "understood": {
      "label": "Here is what I understood",
      "newVersion": "New agent version (based on version {{version}})",
      "youWrote": "You wrote:",
      "tools": "AxiomGO tools the agent will use",
      "missingSteps": "Still to define",
      "limits": "up to {{perRun}} actions per run and {{perDay}} per day"
    },
    "toolKind": {
      "read": "Read only",
      "write": "Changes data"
    },
    "toolLines": {
      "read": "Will read:",
      "write": "Will change:",
      "nothing": "nothing"
    },
    "toolChoice": {
      "add": "Add a tool",
      "remove": "Remove",
      "heading": "Choose the tool to add",
      "mine": "Added by you"
    },
    "toolLabel": {
      "search_work_order": "Read work orders",
      "search_equipment": "Read plant equipment",
      "get_equipment_history": "Read equipment history",
      "update_work_order": "Reschedule or change work order status",
      "create_work_order": "Open a work order",
      "create_notification": "Open a maintenance notice",
      "update_notification": "Fix a notice text",
      "create_task_list": "Build a task list",
      "assign_technician_to_operation": "Assign a technician to an operation",
      "update_equipment": "Change equipment criticality",
      "unknown": "Another AxiomGO tool"
    },
    "autonomy": {
      "propose_and_ask": "Proposes and asks for your approval before acting",
      "act_within_limits": "Acts within the limits"
    },
    "rehearsal": {
      "history": "Rehearsal on real history",
      "snapshot": "Preview of the current state (does not allow activation)",
      "snapshotAdmitted": "Preview of the current state",
      "result": "Would have changed {{affected}} of {{total}}",
      "examples": "e.g.: {{examples}}",
      "status": "Rehearsal: {{status}}"
    },
    "highRisk": "High risk: two judges from different model families"
  },
  "horizonGeneration": {
    "title": "Work-order processing",
    "period": "Requested period: {{from}} to {{to}} ({{months}} months)",
    "loading": "Checking processing…",
    "waiting": "Waiting for processing",
    "processing": "Processing work orders",
    "completed": "Processing completed",
    "partially_completed": "Processing partially completed",
    "failed": "Processing failed",
    "unavailable": "Result cannot yet be verified",
    "progress": "Plans processed: {{finishedPlans}} of {{totalPlans}}",
    "totals": "Occurrences in this run: {{generated}} generated, {{reused}} reused, {{skipped}} skipped and {{failed}} failed.",
    "reconciliation": "{{generatedDistinct}} distinct work orders linked to generated occurrences; {{groupedOccurrences}} additional occurrences grouped into those orders.",
    "reconciliationUnknown": "This receipt cannot confirm the number of distinct work orders linked to generated occurrences.",
    "orders_one": "{{count}} work order found in the requested period.",
    "orders_other": "{{count}} work orders found in the requested period.",
    "failure": "Check the existing work orders and refresh this result before attempting generation again.",
    "readError": "Could not refresh the result. The last verified result, when available, has been preserved.",
    "paused": "Automatic updates have paused. Refresh to check the current state.",
    "refresh": "Refresh processing",
    "showOrders": "View work orders",
    "hideOrders": "Hide work orders",
    "previous": "Previous",
    "next": "Next",
    "orders_zero": "{{count}} work orders found in the requested period."
  },
  "axisCopy": {
    "transicao_apos_tag_base_pronta": [
      "Done, {{tag}} is registered and your asset registry is ready. Your call now: open a corrective work order or build the preventive plan?",
      "{{tag}} saved and your asset registry is ready. What next: a corrective order or a preventive plan?",
      "All set, {{tag}} registered. Your asset registry is ready: corrective or preventive?",
      "I registered {{tag}}. The asset registry is ready to use. Would you rather open a corrective order or build the preventive plan first?",
      "{{tag}} is in the system and the asset registry is complete. Corrective or preventive, which one first?",
      "Good, {{tag}} registered. Your asset registry is ready: which path do you prefer, corrective or preventive?",
      "{{tag}} registered successfully. Asset registry ready. Now choose: open a corrective order or build the preventive plan.",
      "I saved {{tag}}. Your asset registry is ready: shall we go to a corrective order or build the preventive plan first?",
      "Perfect, with {{tag}} your asset registry is complete. Tell me: corrective now or preventive?",
      "{{tag}} registered, asset registry ready to go. What would you like to do: corrective or preventive?",
      "Registered {{tag}}. Asset registry ready. Next step: a corrective work order or the preventive plan?",
      "Done, {{tag}} saved. The asset registry is set: start with a corrective order or a preventive plan?"
    ]
  },
  "equipmentHistory": {
    "closureNote": "Closure note",
    "unavailable": "The received history could not be displayed. Reopen the query to try again.",
    "equipment": "Equipment",
    "actions": "Actions",
    "planEquipment": "Plan / equipment",
    "title": "History of {{tag}}",
    "summary": "{{totalWorkOrders}} work orders and {{totalNotifications}} notifications in this selection; {{activeMaintPlans}} active plans in the query.",
    "scope": "Source: equipment history. Events limited to {{limit}} records per type; dates retain the source time zone.",
    "returned": "{{count}} records received",
    "empty": "No records in this selection.",
    "previous": "Previous",
    "next": "Next",
    "page": "Page {{page}} of {{pages}}",
    "events": "Events",
    "plans": "Preventive plans",
    "date": "Date and time (source)",
    "reference": "Reference",
    "priority": "Priority",
    "status": "Status",
    "description": "Description",
    "frequency": "Frequency / unit",
    "last": "Last execution",
    "nextDue": "Next execution",
    "active": "Active",
    "inactive": "Inactive",
    "units": {"days": "days", "weeks": "weeks", "months": "months", "hours": "hours", "cycles": "cycles", "km": "km", "DAYS": "days", "WEEKS": "weeks", "MONTHS": "months", "HOURS": "hours", "CYCLES": "cycles"}
  },
  "readOnlyList": {
    "unavailable": "This list could not be displayed. Reopen the query to try again.",
    "yes": "Yes",
    "no": "No",
    "received": "{{count}} records received",
    "count": "{{count}} records received out of {{total}} in the query scope",
    "empty": "No records in this selection.",
    "noDescription": "No description",
    "more": "There are more records outside this selection.",
    "unknownScope": "The source did not report whether more records exist beyond this selection.",
    "sources": {
      "search_location": "Locations",
      "search_plant": "Plants",
      "search_supplier": "Suppliers",
      "search_specialty": "Specialties",
      "search_task_list": "Task lists",
      "search_plan_calls": "Plan calls",
      "search_failure_mode": "Failure modes",
      "search_catalog": "Technical catalog",
      "list_team_members": "Team members",
      "list_team_technicians": "Team technicians",
      "list_in_app_alerts": "Alerts",
      "list_import_catalog": "Import templates",
      "list_ltp_scenarios": "Planning scenarios",
      "get_proposals": "Proposals",
      "get_stock_overview": "Stock by plant",
      "query_materials_by_pattern": "Materials by pattern",
      "get_record_history": "Record history",
      "search_work_order": "Work orders",
      "search_technician": "Technicians",
      "search_maint_plan": "Maintenance plans"
    },
    "columns": {
      "code": "Code",
      "name": "Name",
      "description": "Description",
      "plant": "Plant",
      "parent": "Parent location",
      "category": "Category",
      "active": "Active",
      "specialty": "Specialty",
      "operations": "Operations",
      "components": "Components",
      "reference": "Reference",
      "dueDate": "Due date",
      "plannedDate": "Planned date",
      "shiftFollowing": "Shift following",
      "status": "Status",
      "movedAt": "Moved at",
      "moveReason": "Reason",
      "causes": "Causes",
      "manufacturer": "Manufacturer",
      "model": "Model",
      "confidence": "Confidence",
      "lastResearched": "Last researched",
      "role": "Role",
      "membership": "Membership",
      "primary": "Primary",
      "additional": "Additional",
      "type": "Type",
      "priority": "Priority",
      "title": "Title",
      "body": "Report",
      "createdAt": "Created at",
      "read": "Read",
      "requiredFields": "Required fields",
      "optionalFields": "Optional fields",
      "anchorDate": "Start",
      "horizonWeeks": "Horizon in weeks",
      "baselineYear": "Baseline year",
      "createdBy": "Author",
      "equipment": "Equipment",
      "currentStock": "Stock",
      "reservedStock": "Reserved",
      "available": "Available",
      "unit": "Unit",
      "when": "Date and time",
      "who": "Actor",
      "action": "Action",
      "detail": "Detail",
      "unreadCount": "Unread",
      "unreadCriticalCount": "Critical unread",
      "unreadBeyondPage": "Unread outside selection",
      "page": "Page",
      "pageSize": "Page size",
      "limit": "Query limit",
      "recordType": "Record type",
      "plannedStart": "Scheduled start",
      "plannedEnd": "Scheduled end",
      "team": "Team",
      "availability": "Availability on date"
    }
  },
  "manualConflicts": {
    "title": "Different revisions",
    "sideLabel": "Side {{side}}",
    "suggested": "suggested",
    "chosen": "chosen",
    "notChosen": "not chosen",
    "kept": "kept",
    "page": "Page {{page}}",
    "noInterval": "no interval",
    "autoNote": "I used {{used}} ({{usedValue}}). An earlier revision ({{prev}}) exists with {{prevValue}}, just so you know.",
    "usePrevious": "Use {{prev}}",
    "useA": "Use A",
    "useB": "Use B",
    "keepBoth": "Keep both",
    "importWithoutConflicts": "Import only what has no conflict",
    "skipRequested": "Moving on without the conflicts.",
    "error": "I could not save your choice. Try again.",
    "decision": {
      "A": "You used side A. Side B stays marked, not deleted.",
      "B": "You used side B. Side A stays marked, not deleted.",
      "manter_ambas": "You kept both rows in the plan."
    },
    "unit": {
      "HOURS": "h",
      "DAYS": "days",
      "WEEKS": "weeks",
      "MONTHS": "months",
      "YEARS": "years",
      "CYCLES": "cycles"
    }
  },
  "guidedTour": {
    "ajuda": {
      "botao": "Help",
      "titulo": "Help center",
      "fechar": "Close help",
      "abasRotulo": "Help sections",
      "abas": {
        "passos": "First steps",
        "comandos": "Commands",
        "jornada": "Journey"
      },
      "passos": {
        "intro": "Four features to explore at your own pace. Tap Show and AxiomGO points out where it is.",
        "progressoRotulo": "Features already seen",
        "feito": "Already seen",
        "pendente": "Not seen yet",
        "mostrar": "Show",
        "rever": "Review",
        "refazer": "Redo the full tour",
        "refazerDica": "Typing /tour in the message box does the same."
      },
      "itens": {
        "equipe": {
          "titulo": "Team",
          "texto": "See who has access and invite whoever is missing, with the right role for each person."
        },
        "voz": {
          "titulo": "Voice",
          "texto": "Say what you need instead of typing, right from the microphone in the message box."
        },
        "comandos": {
          "titulo": "Commands",
          "texto": "Type / in the message box to see shortcuts for everything AxiomGO does."
        },
        "indicadores": {
          "titulo": "Indicators",
          "texto": "Ready-made questions about maintenance indicators and audits, one tap away."
        }
      },
      "comandos": {
        "intro": "Type / in the message box to use one of these shortcuts.",
        "carregando": "Loading commands…",
        "erro": "Could not load all commands right now. The shortcuts below still work. Close and reopen help to try again.",
        "ajudaLabel": "Open help",
        "ajudaDescricao": "Shows this help center"
      },
      "jornada": {
        "intro": "The path of maintenance in AxiomGO, from the first machine to the monthly numbers.",
        "etapas": {
          "cadastro": {
            "titulo": "Registration",
            "texto": "Tell Axis which equipment you have, or send your spreadsheet and the manufacturer manual."
          },
          "plano": {
            "titulo": "Preventive plan",
            "texto": "AxiomGO suggests the tasks for each piece of equipment and you review them before confirming."
          },
          "ordem": {
            "titulo": "Work order",
            "texto": "From the plan or from a failure, the work order is created in the conversation and goes to the technician."
          },
          "execucao": {
            "titulo": "Execution",
            "texto": "The field technician performs the work, records what was done and closes the order, even by voice."
          },
          "indicadores": {
            "titulo": "Indicators",
            "texto": "With the history recorded, follow maintenance performance and make decisions."
          }
        }
      }
    },
    "botoes": {
      "proximo": "Next",
      "voltar": "Back",
      "concluir": "Done",
      "progresso": "{{current}} of {{total}}",
      "fechar": "Close tour",
      "voltarAoChat": "Back to chat",
      "comecar": "Start"
    },
    "comando": {
      "label": "Replay the guided tour",
      "description": "Shows the AxiomGO walkthrough again",
      "ajuda": {
        "label": "Open the tour help",
        "description": "Shows the features you have seen and the ones still to go"
      },
      "itens": {
        "equipe": "Invite and manage the team",
        "voz": "Speak instead of typing",
        "comandos": "Shortcuts with the slash",
        "indicadores": "Ready-made indicator questions"
      }
    },
    "dicas": {
      "equipe": {
        "titulo": "Your team starts here",
        "texto": "The gear opens Preferences. That is where the team, roles and subscription live. <b>Tap it.</b>",
        "aria": "Tip: invite and manage the team"
      },
      "voz": {
        "titulo": "Speak instead of typing",
        "texto": "Tap the microphone and say what you need. AxiomGO transcribes and runs it. <b>Tap to try.</b>",
        "aria": "Tip: speak instead of typing"
      },
      "comandos": {
        "titulo": "Shortcuts with the slash",
        "texto": "Everything AxiomGO does has a command. <b>Type / in the field</b> to see the list.",
        "aria": "Tip: shortcuts with the slash",
        "lista": {
          "titulo": "The list filters as you type",
          "texto": "Type the first letters to find the command. Use the arrows and Enter, or tap the command."
        }
      },
      "indicadores": {
        "titulo": "Ready-made questions",
        "texto": "This icon opens ready-made questions about maintenance indicators and audit.",
        "aria": "Tip: ready-made indicator questions"
      }
    },
    "passos": {
      "boasVindas": {
        "titulo": "Welcome to AxiomGO",
        "texto": "In a few steps you get your team ready and learn the chat shortcuts. You can skip now: to replay it later, type <b>/tour</b> in the message field."
      },
      "engrenagem": {
        "titulo": "Your team starts here",
        "texto": "The gear opens Preferences. That is where your team, roles and subscription live. <b>Tap it.</b>"
      },
      "equipe": {
        "titulo": "Open Team",
        "texto": "See who already has access and invite whoever is missing. <b>Tap Team.</b>"
      },
      "listaDoTime": {
        "titulo": "Check who is already in",
        "texto": "Each person shows with their role. <b>Admin</b> manages the team, <b>Engineer</b> plans maintenance and <b>Field technician</b> carries out the work orders."
      },
      "convidar": {
        "titulo": "Invite whoever is missing",
        "texto": "The invite goes by email, with an access link valid for 7 days. <b>Tap Invite.</b>"
      },
      "modalConvite": {
        "titulo": "Send the invite",
        "texto": "Type the email, pick the role and confirm. The person gets the link right away."
      },
      "conviteEnviado": {
        "titulo": "Invite sent",
        "texto": "If you prefer, copy the link and send it by WhatsApp. Now back to the chat."
      },
      "microfone": {
        "titulo": "Talk instead of typing",
        "texto": "Tap the microphone and say what you need, for example: <i>\"open a work order for pump B-201\"</i>. AxiomGO transcribes and does it. <b>Tap to try.</b>"
      },
      "barra": {
        "titulo": "Slash shortcuts",
        "texto": "Everything AxiomGO does has a command. <b>Type / in the field</b> to see the list."
      },
      "listaDeComandos": {
        "titulo": "The list filters as you type",
        "texto": "Type the first letters to find the command. Use the arrows and Enter, or tap the command."
      },
      "indicadores": {
        "titulo": "Ready-made questions",
        "texto": "This icon opens ready-made questions about maintenance KPIs and audits."
      },
      "maisAcoes": {
        "titulo": "Attach and more",
        "texto": "With <b>+</b> you send a spreadsheet, the manufacturer manual or an equipment photo right into the conversation."
      },
      "novaConversa": {
        "titulo": "One subject per conversation",
        "texto": "Start a new conversation for each subject. Earlier ones stay in the list, by day."
      },
      "fim": {
        "titulo": "That is it",
        "texto": "To see this walkthrough again anytime, type <b>/tour</b> in the message field and press Enter."
      }
    },
    "avisos": {
      "entendi": "Got it",
      "fechar": "Close notice",
      "ajuda-e-tour": {
        "titulo": "New: Help is now here",
        "texto": "This button holds the <b>step-by-step guide</b>, the <b>commands</b> and the <b>journey</b> of AxiomGO. To see the tour again, type <b>/tour</b> in the message field."
      }
    }
  },
  "tarefaFormatada": {
    "minutos": "{{count}} min",
    "passoDeSeguranca": "Safety step"
  },
  "kairos": {
    "speaker": {
      "kairos": "KAIROS · planning",
      "axis": "AXIS"
    },
    "commands": {
      "kairos": { "label": "Kairos: planning", "description": "plan maintenance from year to weeks" },
      "planejamento": { "label": "Planning (Kairos)", "description": "alias of /kairos" }
    },
    "recommended": "recommended",
    "filter": {
      "label": "Filter by equipment condition",
      "all": "All",
      "stopped": "Machine stopped",
      "running": "Machine running"
    },
    "config": {
      "progress": "How much of the setup is already filled in",
      "source": "Source: {{source}}",
      "edit": "Edit",
      "yourAnswer": "your answer",
      "confidence": {
        "fromData": "from the data",
        "fromDataCheck": "from the data · double-check",
        "goodPractice": "good practice"
      }
    },
    "rules": { "save": "Save rules", "cancel": "Cancel" },
    "crud": {
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save",
      "cancel": "Cancel",
      "fixed": "fixed",
      "fixedHint": "This item cannot be deleted",
      "confirmDelete": "Delete {{name}}?",
      "empty": "No items yet. Use the button above to create the first one.",
      "nothingPending": "Nothing pending here.",
      "newItem": "New item",
      "choose": "choose…",
      "quickTitle": "Finish in 1 click",
      "days": {
        "1": "mon",
        "2": "tue",
        "3": "wed",
        "4": "thu",
        "5": "fri",
        "6": "sat",
        "7": "sun"
      }
    },
    "interview": {
      "label": "Question {{n}} of {{total}}"
    },
    "hub": {
      "intro": "Each part has its own rhythm and opens at any time. It is not a one-time step by step: the plan is alive.",
      "nextLabel": "What to do now"
    }
  }
}
